import { ConfigStateService } from "../../../config/config-state.service";
import { Tenant } from "../../../../shared/types/tenant.enum";
import { UserInfoService } from "../../../user-info.service";
import { TenantConfigService } from "../../../../shared/services/tenant-config.service";


export class TaxReturnPhase {
  static ORIGINAL: TaxReturnPhase = {id: 'original', name: 'Original', badge: ''};
  static REVISION: TaxReturnPhase = {id: 'revision', name: 'Revision', badge: 'R'};
  static AMENDMENT: TaxReturnPhase = {id: 'amendment', name: 'Amendment', badge: 'A'};

  id: string;
  name: string;
  badge: string;
}

export class TaxReturnAction {
  static CREATE: TaxReturnAction = {id: 'create', name: 'Create'};
  static PRE_PREPARE: TaxReturnAction = {id: 'pre-prepare', name: 'Pre-prepare'};
  static COMPLETE_PRE_PREPARE: TaxReturnAction = {id: 'complete-pre-prepare', name: 'Complete pre-preparation', title: 'Complete pre-preparation'};
  static PREPARE: TaxReturnAction = {id: 'prepare', name: 'Prepare'};
  static PROCESS_NO_QNR: TaxReturnAction = {id: 'process-no-qnr', name: 'Start Process'};
  static BULK_PROCESS_NO_QNR: TaxReturnAction = {id: 'bulk-process-no-qnr', name: 'Start Bulk Process'};
  static CHECK_PREFILL_RUN_CALS: TaxReturnAction = {
    id: 'check-prefill-run-cals',
    name: 'Check for Prefill',
   // disabled: ({warningCount, taxReturn}) => warningCount > 0 || taxReturn.generateRobotQueueItemId,
  };
  static GENERATE_TAX_PACKAGE: TaxReturnAction = {
    id: 'generate-tax-package',
    name: 'Generate tax package',
    disabled: ({warningCount, taxReturn}) => warningCount > 0 || taxReturn.generateRobotQueueItemId,
  };
  static GENERATE_FINAL_DOCUMENTS: TaxReturnAction = {
    id: 'generate-final-documents',
    name: 'Generate final documents',
    disabled: ({warningCount, taxReturn}) => warningCount > 0 || taxReturn.generateRobotQueueItemId,
  };
  static GENERATE_TAX_PACKAGE_FINAL: TaxReturnAction = {
    id: 'generate-tax-package-final',
    name: 'Generate tax package',
    disabled: ({warningCount, taxReturn}) => warningCount > 0 || taxReturn.generateRobotQueueItemId,
  };
  static GENERATE_FINAL_DOCUMENTS_FINAL: TaxReturnAction = {
    id: 'generate-final-documents-final',
    name: 'Generate final documents',
    disabled: ({warningCount, taxReturn}) => warningCount > 0 || taxReturn.generateRobotQueueItemId,
  };
  static GENERATE_TAX_PACKAGE_AUTO: TaxReturnAction = {
    id: 'generate-tax-package-auto',
    // name: 'Generate - one click',
    name: 'Generate tax package',
    disabled: ({warningCount, taxReturn}) => warningCount > 0 || taxReturn.generateRobotQueueItemId,
  };
  static GENERATE_TAX_PACKAGE_MANUAL: TaxReturnAction = {
    id: 'generate-tax-package-manual',
    name: 'Generate - manual',
    disabled: ({warningCount, taxReturn}) => warningCount > 0 || taxReturn.generateRobotQueueItemId,
  };
  static SUBMIT_FOR_REVIEW: TaxReturnAction = {id: 'submit-for-review', name: 'Submit for review'};
  static REVIEW: TaxReturnAction = {id: 'review', name: 'Review'};
  static BACK_FOR_CHANGES: TaxReturnAction = {id: 'back-for-changes', name: 'Back for changes', title: 'Send back for changes'};
  static REVIEW_COMPLETED: TaxReturnAction = {id: 'review-completed', name: 'Review completed'};
  static PREVIEW_FINAL_PACKAGE: TaxReturnAction = {
    id: 'create-final-package-preview',
    name: 'Create final package',
    disabled: ({warningCount, taxReturn, config, userInfo}) => {
      if (config.featureFlags.onlyReviewersCanGeneratefinalPackage) {
        const isUserReviewer = taxReturn.reviewer.some(r => r.id === userInfo.id);
        const isUserAdmin = userInfo.isAdmin;
        return !(isUserReviewer || isUserAdmin);
      }
      return false;
    },
  };
  static FILES_SENT_TO_CLIENT: TaxReturnAction = {
    id: 'files-sent-to-client',
    name: 'Files sent to client',
    disabled: ({warningCount, taxReturn, config, userInfo}) => {
      if (config.featureFlags.onlyReviewersCanGeneratefinalPackage) {
        const isUserReviewer = taxReturn.reviewer.some(r => r.id === userInfo.id);
        const isUserAdmin = userInfo.isAdmin;
        return !(isUserReviewer || isUserAdmin);
      }
      return false;
    },
  };
  static RESUBMIT_EMPLOYER_FINAL_PACKAGE: TaxReturnAction = {
    id: 'resubmit-employer-final-package',
    name: 'Resubmit to employer',
    disabled: ({warningCount, taxReturn, config, userInfo}) => {
      if (config.featureFlags.onlyReviewersCanGeneratefinalPackage) {
        const isUserReviewer = taxReturn.reviewer.some(r => r.id === userInfo.id);
        const isUserAdmin = userInfo.isAdmin;
        return !(isUserReviewer || isUserAdmin);
      }
      return false;
    },
  };
  static CREATE_FINAL_PACKAGE: TaxReturnAction = {
    id: 'create-final-package',
    name: 'Create final package',
    disabled: ({warningCount, taxReturn, config, userInfo}) => {
      if (config.featureFlags.onlyReviewersCanGeneratefinalPackage) {
        const isUserReviewer = taxReturn.reviewer.some(r => r.id === userInfo.id);
        const isUserAdmin = userInfo.isAdmin;
        return !(isUserReviewer || isUserAdmin);
      }
      return false;
    },
  };
  static SUBMIT_TO_ASSIGNEE: TaxReturnAction = {
    id: 'submit-to-assignee',
    name: 'Submit to assignee',
    disabled: ({warningCount, taxReturn, config, userInfo}) => {
      if (config.featureFlags.onlyReviewersCanGeneratefinalPackage) {
        const isUserReviewer = taxReturn.reviewer.some(r => r.id === userInfo.id);
        const isUserAdmin = userInfo.isAdmin;
        return !(isUserReviewer || isUserAdmin);
      }
      return false;
    },
  };
  static TAXPAYER_ACCEPTED: TaxReturnAction = {
    id: 'taxpayer-accepted',
    name: '', // no name because its an icon
    title: 'Taxpayer accepted',
    hasUserRestriction: (config: ConfigStateService, userInfo: UserInfoService) => {
    if (config.tenant === Tenant.FR || config.tenant === Tenant.SG) { return false; }

      const restrictedToAdminOnly = true;
      return (restrictedToAdminOnly && !userInfo.isAdmin);
    }
  };
  static EMPLOYER_ACCEPTED: TaxReturnAction = {
    id: 'employer-accepted',
    name: '', // no name because its an icon
    title: 'Employer accepted',
    hasUserRestriction: (config: ConfigStateService, userInfo: UserInfoService) => {
      if (config.tenant === Tenant.FR || config.tenant === Tenant.SG) { return false; }

      const restrictedToAdminOnly = true;
      return (restrictedToAdminOnly && !userInfo.isAdmin);
    }
  };
  static MARK_AS_LODGED: TaxReturnAction = {
    id: 'employer-accepted',
    name: '', // no name because its an icon
    title: 'Mark as lodged',
    hasUserRestriction: (config: ConfigStateService, userInfo: UserInfoService) => {
      if (config.tenant === Tenant.FR) { return false; }

      const restrictedToAdminOnly = true;
      return (restrictedToAdminOnly && !userInfo.isAdmin);
    }
  };
  static TAXPAYER_EMPLOYER_ACCEPTED: TaxReturnAction = {
    id: 'taxpayer-employer-accepted',
    name: '', // no name because its an icon
    title: 'Taxpayer and Employer accepted',
    hasUserRestriction: (config: ConfigStateService, userInfo: UserInfoService) => {
      if (config.tenant === Tenant.FR || config.tenant === Tenant.SG) { return false; }

      const restrictedToAdminOnly = true;
      return (restrictedToAdminOnly && !userInfo.isAdmin);
    }
  };
  static TAXPAYER_EMPLOYER_REJECTED: TaxReturnAction = {id: 'taxpayer-employer-rejected', name: '', title: 'Taxpayer and Employer rejected'}; // no name because its an icon
  static LODGED: TaxReturnAction = {id: 'lodged', name: 'Lodged'};
  static AMEND: TaxReturnAction = {id: 'amend', name: 'Amend'};
  static REVISE: TaxReturnAction = {id: 'revise', name: 'Revise'};

  // China/HK Actions
  static LINK_FAIL_UPLOAD_NEXT: TaxReturnAction = {id: 'link-fail-upload-next', name: 'Next', title: 'Uploaded Link Manually'};
  static EXCEPTION_FILING: TaxReturnAction = {id: 'exception-filing', name: 'Exception Filing'};
  static KPMG_TO_LODGE: TaxReturnAction = {id: 'kpmg-to-lodge', name: "KPMG to lodge"};
  static TAXPAYER_ACCEPTED_BUTTON: TaxReturnAction = {id: 'taxpayer-accepted', name: 'Next', title: 'Next'};
  static TAXPAYER_ACCEPTED_ARROW: TaxReturnAction = {id: 'taxpayer-accepted-arrow', name: 'Next', title: 'Approved – Ready for Lodgement'};
  static TAXPAYER_ACCEPTED_NEXT: TaxReturnAction = {id: 'taxpayer-accepted-next', name: 'Next', title: 'Approved – Ready for Lodgement'};
  static TAXPAYER_REJECTED_BUTTON: TaxReturnAction = {id: 'taxpayer-rejected', name: 'Back For Changes', title: 'Back For Changes'};
  static EMPLOYER_REJECTED_BACK: TaxReturnAction = {id: 'revise-back-employer', name: 'Back For Changes', title:'Back For Changes'};
  static EMPLOYER_REJECTED_BACK_BUTTON: TaxReturnAction = {id: 'revise-back-employer-button', name: 'Back For Changes', title:'Back For Changes'};
  static EMPLOYER_ACCEPTED_NEXT: TaxReturnAction = {id: 'employer-accepted-next', name: 'Next', title: 'Approved – Ready for Lodgement'};
  static EMPLOYER_ACCEPTED_NEXT_BUTTON: TaxReturnAction = {id: 'employer-accepted-next-button', name: 'Next', title: 'Approved – Ready for Lodgement'};
  static LODGED_NEXT: TaxReturnAction = {id: 'lodged-next', name: 'Next', title: 'Approved – Ready for Lodgement'};
  static LODGED_NEXT_LODGED: TaxReturnAction = {id: 'lodged-next', name: 'Next', title: 'Move to Lodged'};
  static LODGED_ARROW: TaxReturnAction = {id: 'lodged-arrow', name: 'Next', title: 'Approved – Ready for Lodgement'};
  static INFORMATION_NOT_COMPLETE: TaxReturnAction = {id: 'information-not-complete', name: 'Information Not Complete'};
  static CHECK_PRINTED_PACKAGE: TaxReturnAction = {id: 'check-printed-package', name: 'Review Printed Package'};
  static CHECK_PRINTED_PACKAGE_NEXT: TaxReturnAction = {id: 'check-printed-package', name: 'Next', title:'Review Finalised Package'};
  static SEND_FOR_PRINTING: TaxReturnAction = {id: 'send-for-printing', name: 'Next', title: 'Send Back For Printing'};
  static SEND_FOR_PRINTING_CHECKING: TaxReturnAction = {id: 'send-for-printing-approve', name: 'Next', title: 'Sent to Be Printed (Refine Package)'};
  static SEND_FOR_PRINTING_REJECT: TaxReturnAction = {id: 'send-for-printing-reject', name: 'Refine Package', title: 'Sent to Be Printed (Refine Package)'};
  static SEND_FOR_PRINTING_ARROW: TaxReturnAction = {id: 'send-for-printing-arrow', name: 'Next', title: 'Send Back For Printing'};
  static SEND_FOR_PRINTING_REFINE: TaxReturnAction = {id: 'send-for-printing-secondary', name: 'Refine Package', title: 'Sent to Be Printed (Refine Package)'};
  static PRINTED_PACKAGE_READY_TO_SEND: TaxReturnAction = {id: 'printed-package-ready-to-send', name: 'Next', title: 'Ready to Send'}
  static PRINTED_PACKAGE_READY_TO_SEND_ACCEPTED: TaxReturnAction = {id: 'printed-package-ready-to-send-accept', name: 'Next', title: 'Ready to Send'}
  static REVISE_BACK_FOR_CHANGES: TaxReturnAction = {id: 'revise-back', name: 'Back For Changes', title:'Back For Changes'};
  static REVISE_BACK_FOR_CHANGES_SECONDARY: TaxReturnAction = {id: 'revise-back-secondary', name: 'Back For Changes', title:'Back For Changes'};

  static  TAXPAYER_REJECTED: TaxReturnAction = {
    id: 'taxpayer-rejected', name: 'Next', title: `${(config: ConfigStateService) => new TenantConfigService(config).config.taxpayerAlias} rejected`,
  }; // no name because its an icon
  static  EMPLOYER_REJECTED: TaxReturnAction = {
    id: 'employer-rejected', name: 'Next', title: `${(config: ConfigStateService) => new TenantConfigService(config).config.taxpayerAlias} rejected`,
  }; // no name because its an icon
  static  QUESTION_DRIVEN_STATUS: TaxReturnAction = {
    id: 'question-driven-status', name: 'Next', title: `Next: Status driven by answer in ${(config: ConfigStateService) => new TenantConfigService(config).config.taxReturnAlias}`,
  };
  static  QUESTION_DRIVEN_STATUS_NEXT: TaxReturnAction = {
    id: 'question-driven-status-next', name: 'Next', title: `Next: Status driven by answer in ${(config: ConfigStateService) => new TenantConfigService(config).config.taxReturnAlias}`,
  };

  id: string;
  name?: string;
  title?: string; // hover title text
  disabled?: (
    options: {warningCount: number, taxReturn: any, config: ConfigStateService, userInfo: UserInfoService},
  ) => boolean;
  adminOnly?: boolean;
  hasUserRestriction?: (config: ConfigStateService, userInfo: UserInfoService) => boolean; // return TRUE to restrict action based on tenant and/or user
}

export class TaxReturnStep {

  static QUESTIONNAIRE_OUTSTANDING: TaxReturnStep = {
    id: 'questionnaire-outstanding',
    name: (config: ConfigStateService) => config.tenant === Tenant.JPCORP ? 'Waiting for Preparation': 'Questionnaire Outstanding',
    listActions: (config: ConfigStateService) => {
      if (config.featureFlags.aps) {
        return [TaxReturnAction.CREATE]
      }else {
        return config.tenant === Tenant.JPCORP ? [TaxReturnAction.PREPARE] : [TaxReturnAction.PRE_PREPARE]
      }
    }
  };
  static WAITING_TO_CREATE_SIMPLE_QNR: TaxReturnStep = {
    id: 'waiting-to-create-simple-qnr',
    name: (config: ConfigStateService) => 'Waiting to Create Simple QNR',
    listActions: (config: ConfigStateService) => [],
  };
  static READY_TO_RUN_CALCS: TaxReturnStep = {
    id: 'ready-to-run-calcs',
    name: (config: ConfigStateService) => 'Ready to run calcs',
    listActions: (config: ConfigStateService) => [ TaxReturnAction.CREATE ]
  };
  static WAITING_PROCESSING_NO_QNR: TaxReturnStep = {
    id: 'waiting-processing-noqnr',
    name: (config: ConfigStateService) => 'Awaiting Processing - No QNR',
    listActions: (config: ConfigStateService) => [TaxReturnAction.PROCESS_NO_QNR]
  };
  static WAITING_FOR_PREFILL: TaxReturnStep = {
    id: 'waiting-for-prefill',
    name: (config: ConfigStateService) => 'Waiting For Prefill',
    listActions: (config: ConfigStateService) => [TaxReturnAction.CHECK_PREFILL_RUN_CALS],
  };
  static FAILED_TO_CREATE_SIMPLE_QNR: TaxReturnStep = {
    id: 'failed-to-create-simple-qnr',
    name: (config: ConfigStateService) => 'Failed to Create Simple QNR',
    listActions: (config: ConfigStateService) => [],
  };
  static SIMPLE_QNR_OUTSTANDING: TaxReturnStep = {
    id: 'simple-qnr-outstanding',
    name: (config: ConfigStateService) => 'Simple QNR Outstanding',
    listActions: (config: ConfigStateService) => [TaxReturnAction.CREATE],
  };
  static SIMPLE_QNR_LOAD_FAILED: TaxReturnStep = {
    id: 'simple-qnr-load-failed',
    name: (config: ConfigStateService) => 'Simple QNR - Load Failed',
    listActions: (config: ConfigStateService) => [TaxReturnAction.CREATE],
  };
  static WAITING_FOR_ITR_ROBOT: TaxReturnStep = {
    id: 'waiting-for-itr-robot',
    name: (config: ConfigStateService) => 'Waiting for ITR Robot',
    listActions: (config: ConfigStateService) => config.featureFlags.aps ? [TaxReturnAction.CREATE] : [TaxReturnAction.PRE_PREPARE],
  };
  static LODGEMENT_FAILED: TaxReturnStep = {
    id: 'lodgement-failed',
    name: (config: ConfigStateService) => 'Lodgement Failed',
    listActions: (config: ConfigStateService) => [],
  };
  static PRE_PREPARATION: TaxReturnStep = {
    id: 'pre-preparation',
    name: (config: ConfigStateService) => 'Pre-preparation',
    listActions: (config: ConfigStateService) => [TaxReturnAction.PRE_PREPARE],
    complexityField: 'complexityPreparer',
  };
  static WAITING_FOR_PRE_PREPARATION: TaxReturnStep = {
    id: 'waiting-for-pre-preparation',
    name: (config: ConfigStateService) => 'Waiting for pre-preparation',
    listActions: (config: ConfigStateService) => [TaxReturnAction.PRE_PREPARE],
    complexityField: 'complexityPreparer',
  };

  static READY_FOR_PREP: TaxReturnStep = {
    id: 'ready-for-preparation',
    name: (config: ConfigStateService) => 'Ready for Preparation',
    listActions: (config: ConfigStateService) => [TaxReturnAction.PREPARE],
    complexityField: 'complexityPreparer',
  };
  static PREPARATION: TaxReturnStep = {
    id: 'preparation',
    name: (config: ConfigStateService) => 'Preparation',
    listActions: (config: ConfigStateService) => [TaxReturnAction.PREPARE],
    complexityField: 'complexityPreparer',
  };
  static PREP_WAITING_FOR_PACKAGE_GENERATION: TaxReturnStep = {
    id: 'prep-package-generating',
    name: (config: ConfigStateService) => 'Prep - Package Generating',
    listActions: (config: ConfigStateService) => [],
    complexityField: 'complexityPreparer',
  };
  static PREP_PACKAGE_GENERATED: TaxReturnStep = {
    id: 'prep-package-generated',
    name: (config: ConfigStateService) => 'Prep - Package Generated',
    listActions: (config: ConfigStateService) => [TaxReturnAction.SUBMIT_FOR_REVIEW, TaxReturnAction.BACK_FOR_CHANGES],
    complexityField: 'complexityPreparer',
  };
  static IN_REVIEW: TaxReturnStep = {
    id: 'in-review',
    name: (config: ConfigStateService) => 'In Review',
    listActions: (config: ConfigStateService) => [TaxReturnAction.REVIEW],
    complexityField: 'complexityReviewer1',
  };

  static FIRST_REVIEW: TaxReturnStep = {
    id: 'first-review',
    name: (config: ConfigStateService) => 'First Review',
    listActions: (config: ConfigStateService) => [TaxReturnAction.REVIEW],
    complexityField: 'complexityReviewer1',
  };

  static READY_FOR_REVIEW: TaxReturnStep = {
    id: 'ready-for-review',
    name: (config: ConfigStateService) => 'Ready for Review',
    listActions: (config: ConfigStateService) => [TaxReturnAction.REVIEW],
    complexityField: 'complexityReviewer1',
  };
  static FIRST_REVIEW_WAITING_FOR_PACKAGE_GENERATION: TaxReturnStep = {
    id: 'first-review-package-generating',
    name: (config: ConfigStateService) => 'First Review - Package Generating',
    listActions: (config: ConfigStateService) => [],
    complexityField: 'complexityReviewer1',
  };
  static FIRST_REVIEW_PACKAGE_GENERATED: TaxReturnStep = {
    id: 'first-review-package-generated',
    name: (config: ConfigStateService) => 'First Review - Package Generated',
    listActions: (config: ConfigStateService) => [TaxReturnAction.REVIEW_COMPLETED, TaxReturnAction.BACK_FOR_CHANGES],
    complexityField: 'complexityReviewer1',
  };
  static SECOND_REVIEW: TaxReturnStep = {
    id: 'second-review',
    name: (config: ConfigStateService) => 'Second Review',
    listActions: (config: ConfigStateService) => [TaxReturnAction.REVIEW],
    complexityField: 'complexityReviewer2',
  };
  static SECOND_REVIEW_WAITING_FOR_PACKAGE_GENERATION: TaxReturnStep = {
    id: 'second-review-package-generating',
    name: (config: ConfigStateService) => 'Second Review - Package Generating',
    listActions: (config: ConfigStateService) => [],
    complexityField: 'complexityReviewer2',
  };
  static SECOND_REVIEW_PACKAGE_GENERATED: TaxReturnStep = {
    id: 'second-review-package-generated',
    name: (config: ConfigStateService) => 'Second Review - Package Generated',
    listActions: (config: ConfigStateService) => config.tenant === Tenant.AU ? [TaxReturnAction.PREVIEW_FINAL_PACKAGE, TaxReturnAction.BACK_FOR_CHANGES] : [],
    complexityField: 'complexityReviewer2',
  };
  static SECOND_REVIEW_FINAL_PACKAGE_SUBMITTING: TaxReturnStep = {
    id: 'second-review-final-package-submitting',
    name: (config: ConfigStateService) => 'Second Review - Submitting Final Package',
    listActions: (config: ConfigStateService) => [],
    complexityField: 'complexityReviewer2',
  };
  static LINK_FAIL_UPLOAD: TaxReturnStep = {
    id: 'link-fail-upload',
    name: (config: ConfigStateService) => 'LINK Fail Upload',
    listActions: (config: ConfigStateService) => []
  };
  static AWAITING_TAXPAYER_APPROVAL: TaxReturnStep = {
    id: 'awaiting-taxpayer-approval',
    name: (config: ConfigStateService) => 'Awaiting Taxpayer Approval',
    listActions: (config: ConfigStateService) => config.tenant === Tenant.HK || config.tenant === Tenant.CN ? [TaxReturnAction.TAXPAYER_ACCEPTED_BUTTON, TaxReturnAction.TAXPAYER_REJECTED_BUTTON] : [],
  };
  static AWAITING_EMPLOYER_APPROVAL: TaxReturnStep = {
    id: 'awaiting-employer-approval',
    name: (config: ConfigStateService) => 'Awaiting Employer Approval',
    listActions: (config: ConfigStateService) => config.tenant === Tenant.HK || config.tenant === Tenant.CN ?
      [ TaxReturnAction.EMPLOYER_ACCEPTED_NEXT_BUTTON, TaxReturnAction.EMPLOYER_REJECTED_BACK_BUTTON]:
      [],
  };

  static AWAITING_CLIENT_APPROVAL: TaxReturnStep = {
    id: 'awaiting-client-approval',
    name: (config: ConfigStateService) => 'Awaiting Client Approval',
    listActions: (config: ConfigStateService) => config.tenant === Tenant.HK || config.tenant === Tenant.CN ? [TaxReturnAction.EMPLOYER_ACCEPTED, TaxReturnAction.EMPLOYER_REJECTED] : [],
  };
  static AWAITING_TAXPAYER_EMPLOYER_APPROVAL: TaxReturnStep = {
    id: 'awaiting-taxpayer-employer-approval',
    name: (config: ConfigStateService) => 'Awaiting Taxpayer and Employer Approval',
    listActions: (config: ConfigStateService) => [],
  };

  static TAXPAYER_SUBMITTED_EMPLOYER_FAILED: TaxReturnStep = {
    id: 'awaiting-taxpayer-approval-employer-submitted',
    name: (config: ConfigStateService) => 'Submitted to Taxpayer / Employer Failed',
    listActions: (config: ConfigStateService) => [],
  };
  static TAXPAYER_APPROVED_EMPLOYER_FAILED: TaxReturnStep = {
    id: 'taxpayer-approved-employer-failed',
    name: (config: ConfigStateService) => 'Taxpayer Approved / Employer Submission Failed',
    listActions: (config: ConfigStateService) => [],
  };
  static TAXPAYER_REJECTED: TaxReturnStep = {
    id: 'taxpayer-rejected',
    name: (config: ConfigStateService) => `${new TenantConfigService(config).config.taxReturnAlias} Rejected`,
    listActions: (config: ConfigStateService) => [TaxReturnAction.REVISE],
  };
  static SENT_FOR_LODGEMENT: TaxReturnStep = {
    id: 'sent-for-lodgement',
    name: (config: ConfigStateService) => 'Sent For Lodgement',
    listActions: (config: ConfigStateService) => config.tenant === Tenant.HK || config.tenant === Tenant.CN ? [TaxReturnAction.LODGED_ARROW] : [],
  };
  static LODGED: TaxReturnStep = {
    id: 'lodged',
    name: (config: ConfigStateService) => config.tenant === Tenant.FR ? 'Finalised' : 'Lodged',
    listActions: (config: ConfigStateService) => [TaxReturnAction.AMEND],
  };
  static LODGED_NEXT: TaxReturnStep = {
    id: 'lodged-next',
    name: (config: ConfigStateService) => 'Lodged',
    listActions: (config: ConfigStateService) => [TaxReturnAction.AMEND],
  };
  static LODGED_ARROW: TaxReturnStep = {
    id: 'lodged-arrow',
    name: (config: ConfigStateService) => 'Lodged',
    listActions: (config: ConfigStateService) => [TaxReturnAction.AMEND],
  };


  static CHECKING_FOR_PREFILL: TaxReturnStep = {
    id: 'checking-for-prefill',
    name: (config: ConfigStateService) => 'Checking For Prefill',
    listActions: (config: ConfigStateService) => [],
  };

  static PREFILL_LOAD_FAILED: TaxReturnStep = {
    id: 'prefill-load-failed',
    name: (config: ConfigStateService) => 'Prefill load failed',
    listActions: (config: ConfigStateService) => [],
  };

  static READY_TO_RUN_CALCS_SQNR: TaxReturnStep = {
    id: 'ready-to-run-calcs-sqnr',
    name: (config: ConfigStateService) => 'Ready to runcalcs SQNR',
    listActions: (config: ConfigStateService) => [],
  };
  static ELECTRONIC_PACKAGE_SENT: TaxReturnStep = {
    id: 'electronic-package-sent',
    name: (config: ConfigStateService) => 'Electronic Package Sent',
    listActions: (config: ConfigStateService) => [],
  }
  static ELECTRONIC_PACKAGE_SENT_TAXPAYER_TO_LODGE: TaxReturnStep = {
    id: 'electronic-package-sent-taxpayer-to-lodge',
    name: (config: ConfigStateService) => config.tenant === Tenant.FR ? 'Package Sent to Taxpayer' : 'Electronic Package Sent: TP to Lodge',
    listActions: (config: ConfigStateService) => [],
  }
  static ELECTRONIC_PACKAGE_SENT_CLIENT_TO_LODGE: TaxReturnStep = {
    id: 'electronic-package-sent-client-to-lodge',
    name: (config: ConfigStateService) => 'Electronic Package Sent: Client to Lodge',
    listActions: (config: ConfigStateService) => [],
  }
  static EXEPTION_FILING: TaxReturnStep = {
    id: 'exception-filing',
    name: (config: ConfigStateService) => 'Exception Filing',
    listActions: (config: ConfigStateService) => [],
  }
  static EXEPTION_FILING_AWAITING: TaxReturnStep = {
    id: 'exception-filing',
    name: (config: ConfigStateService) => 'Awaiting Exception Filing',
    listActions: (config: ConfigStateService) => [],
  }

  static KPMG_TO_LODGE: TaxReturnStep = {
    id: 'kpmg-to-lodge',
    name: (config: ConfigStateService) => 'Next',
    listActions: (config: ConfigStateService) => [],
  }
  static SENT_FOR_PRINTING: TaxReturnStep = {
    id: 'sent-for-printing',
    name: (config: ConfigStateService) => 'Sent For Printing',
    listActions: (config: ConfigStateService) => [],
  };
  static INFORMATION_NOT_COMPLETE: TaxReturnStep = {
    id: 'information-not-complete',
    name: (config: ConfigStateService) => 'Back To Team : Not Enough Info For Print',
    listActions: (config: ConfigStateService) => [TaxReturnAction.SEND_FOR_PRINTING_ARROW],
  };

  static PRINTED_PACKAGE_WAITING_FOR_CHECKING: TaxReturnStep = {
    id: 'check-printed-package',
    name: (config: ConfigStateService) => 'Printed Package: Waiting For Checking',
    listActions: (config: ConfigStateService) => [TaxReturnAction.PRINTED_PACKAGE_READY_TO_SEND_ACCEPTED, TaxReturnAction.SEND_FOR_PRINTING_REJECT],
  };

  static READY_TO_SEND: TaxReturnStep = {
    id: 'ready-to-send',
    name: (config: ConfigStateService) => 'Printed Package: Ready to Send',
    listActions: (config: ConfigStateService) => [TaxReturnAction.QUESTION_DRIVEN_STATUS_NEXT],
  };

  static PHYSICAL_PACKAGE_SENT_CLIENT_TO_LODGE: TaxReturnStep = {
    id: 'physical-package-sent-client-to-lodge',
    name: (config: ConfigStateService) => 'Physical Package Sent: Client To Lodge',
    listActions: (config: ConfigStateService) => [],
  };

  static PHYSICAL_PACKAGE_SENT_CLIENT_TO_RETURN_TO_KPMG: TaxReturnStep = {
    id: 'physical-package-sent-client-to-return-to-kpmg',
    name: (config: ConfigStateService) => 'Physical Package Sent: Client To Return',
    listActions: (config: ConfigStateService) => [TaxReturnAction.TAXPAYER_ACCEPTED_ARROW],
  };

  static PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_LODGE: TaxReturnStep = {
    id: 'physical-package-sent-taxpayer-to-lodge',
    name: (config: ConfigStateService) => 'Physical Package Sent: TP To Lodge',
    listActions: (config: ConfigStateService) => [],
  };

  static PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_RETURN_TO_KPMG: TaxReturnStep = {
    id: 'physical-package-sent-taxpayer-to-return-to-kpmg',
    name: (config: ConfigStateService) => 'Physical Package Sent: TP To Return to KPMG',
    listActions: (config: ConfigStateService) => [TaxReturnAction.TAXPAYER_ACCEPTED_ARROW],
  };

  static LODGEMENT_IN_PROGRESS: TaxReturnStep = {
    id: 'lodgment-in-progress',
    name: (config: ConfigStateService) => 'Lodgement in Progress',
    listActions: (config: ConfigStateService) => [],
  };

  static TAXPAYER: TaxReturnStep = {
    id: 'taxpayer',
    name: (config: ConfigStateService) => 'Taxpayer',
    listActions: (config: ConfigStateService) => [],
  }

  static SENDING_TO_DIGITAL_GATEWAY_UPLOAD: TaxReturnStep = {
    id: 'sending-to-digital-gateway',
    name: (config: ConfigStateService) => 'Sending To Digital Gateway',
    listActions: (config: ConfigStateService) => [],
  };

  static SENT_TO_DIGITAL_GATEWAY_UPLOAD: TaxReturnStep = {
    id: 'sent-to-digital-gateway',
    name: (config: ConfigStateService) => 'Sent To Digital Gateway',
    listActions: (config: ConfigStateService) => [],
  };

  static CLOSED: TaxReturnStep = {
    id: 'closed',
    name: (config: ConfigStateService) => 'Closed',
    listActions: (config: ConfigStateService) => [],
  }
  static RESPONSE_FROM_ONE_TEAM: TaxReturnStep = {
    id: 'response-from-one-item',
    name: (config: ConfigStateService) => 'Response From Collaborate',
    listActions: (config: ConfigStateService) => [],
  };

  id: string;
  name: (config: ConfigStateService) => string;
  listActions: (config: ConfigStateService) => TaxReturnAction[];
  complexityField?: string;

}

let taxReturnStatusById = null;

export class TaxReturnStatus {
  // PREP/REVIEW
  static QUESTIONNAIRE_OUTSTANDING: TaxReturnStatus = {
    id: 0, // notStarted
    name: "Questionnaire Outstanding",
    step: TaxReturnStep.QUESTIONNAIRE_OUTSTANDING,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => {
      if (config.featureFlags.aps) {
        return [TaxReturnAction.CREATE]
      }else {
        return config.tenant === Tenant.JPCORP ? [TaxReturnAction.PREPARE] : [TaxReturnAction.PRE_PREPARE]
      }
    },
    snapshotName: "Questionnaire Outstanding",
  };
  static QUESTIONNAIRE_LOAD_FAILED: TaxReturnStatus = {
    id: 80, // questionnaireLoadFail
    name: "Questionnaire Outstanding - Load Failed",
    step: TaxReturnStep.QUESTIONNAIRE_OUTSTANDING,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => config.featureFlags.aps ? [TaxReturnAction.CREATE] : [TaxReturnAction.PREPARE],
    snapshotName: "Questionnaire Outstanding - Load Failed",
  };
  static WAITING_TO_CREATE_SIMPLE_QNR: TaxReturnStatus = {
    id: 84,
    name: "Waiting to Create Simple QNR",
    step: TaxReturnStep.WAITING_TO_CREATE_SIMPLE_QNR,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Waiting to Create Simple QNR",
  };

  static READY_TO_RUN_CALCS: TaxReturnStatus = {
    id: 89,
    name: "Ready to run calcs",
    step: TaxReturnStep.READY_TO_RUN_CALCS,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.CREATE],
    snapshotName: "Ready to run calcs",
  };
  static WAITING_PROCESSING_NO_QNR: TaxReturnStatus = {
    id: 88,
    name: "Awaiting Processing - No QNR",
    step: TaxReturnStep.WAITING_PROCESSING_NO_QNR,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.PROCESS_NO_QNR],
    snapshotName: "Awaiting Processing - No QNR",
  };
  static WAITING_FOR_PREFILL: TaxReturnStatus = {
    id: 90,
    name: "Waiting For Prefill",
    step: TaxReturnStep.WAITING_FOR_PREFILL,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.CHECK_PREFILL_RUN_CALS],
    snapshotName: "Waiting For Prefill",
  };
  static FAILED_TO_CREATE_SIMPLE_QNR: TaxReturnStatus = {
    id: 85,
    name: "Failed to Create Simple QNR",
    step: TaxReturnStep.FAILED_TO_CREATE_SIMPLE_QNR,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Failed to Create Simple QNR",
  };
  static SIMPLE_QNR_OUTSTANDING: TaxReturnStatus = {
    id: 86,
    name: "Simple QNR Outstanding",
    step: TaxReturnStep.SIMPLE_QNR_OUTSTANDING,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.CREATE],
    snapshotName: "Simple QNR Outstanding",
  };
  static SIMPLE_QNR_LOAD_FAILED: TaxReturnStatus = {
    id: 87,
    name: "Simple QNR - Load Failed",
    step: TaxReturnStep.SIMPLE_QNR_LOAD_FAILED,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.CREATE],
    snapshotName: "Simple QNR - Load Failed",
  };
  static WAITING_FOR_ITR_ROBOT: TaxReturnStatus = {
    id: 81, // waitingForITRRobotProcess
    name: "Waiting for ITR Robot",
    step: TaxReturnStep.WAITING_FOR_ITR_ROBOT,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => config.featureFlags.aps ? [TaxReturnAction.CREATE] : [TaxReturnAction.PRE_PREPARE],
    snapshotName: "Waiting for ITR Robot",
  };
  static ITR_ROBOT_FAILED: TaxReturnStatus = {
    id: 82, // ITRRobotFail
    name: "ITR Robot Failed",
    step: TaxReturnStep.WAITING_FOR_ITR_ROBOT,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => config.featureFlags.aps ? [TaxReturnAction.CREATE] : [TaxReturnAction.PRE_PREPARE],
    snapshotName: "ITR Robot Failed",
  };
  static LODGEMENT_FAILED: TaxReturnStatus = {
    id: 83,
    name: "Lodgement Failed",
    step: TaxReturnStep.LODGEMENT_FAILED,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Lodgement Failed",
  };
  static READY_FOR_PREPARATION: TaxReturnStatus = {
    id: 50, // waitingForPrep
    name: "Ready for preparation",
    step: TaxReturnStep.PREPARATION,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.PREPARE],
    snapshotName: "Ready for Preparation",
  };

  static PRE_PREPARATION: TaxReturnStatus = {
    id: 100, // prePrep
    name: "Pre-preparation",
    step: TaxReturnStep.PRE_PREPARATION,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.COMPLETE_PRE_PREPARE],
    inPrep: true,
    snapshotName: "Pre-preparation",
  };
  static WAITING_FOR_PRE_PREPARATION: TaxReturnStatus = {
    id: 113, // waitingForPrePrep
    name: "Waiting for pre-preparation",
    step: TaxReturnStep.WAITING_FOR_PRE_PREPARATION,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.PRE_PREPARE],
    inPrep: true,
    snapshotName: "Waiting for pre-preparation",
  };
  static IN_PREPARATION: TaxReturnStatus = {
    id: 1, // prep
    name: "In preparation",
    step: TaxReturnStep.PREPARATION,
    phase: TaxReturnPhase.ORIGINAL,
    inPrep: true,
    actions: (config: ConfigStateService) => config.tenant === Tenant.FR ? [TaxReturnAction.GENERATE_FINAL_DOCUMENTS] : [TaxReturnAction.GENERATE_TAX_PACKAGE],
    snapshotName: "Preparation",
  };

  static PREP_GENERATING_TAX_RETURN: TaxReturnStatus = {
    id: 58,
    name: "Sent for package generation",
    step: TaxReturnStep.PREP_WAITING_FOR_PACKAGE_GENERATION,
    phase: TaxReturnPhase.ORIGINAL,
    readOnly: true,
    inPrep: true,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Preparation - Generating Package",
  };
  static PREP_GENERATION_COMPLETE: TaxReturnStatus = {
    id: 61,
    name: "Package generation complete",
    step: TaxReturnStep.PREP_PACKAGE_GENERATED,
    phase: TaxReturnPhase.ORIGINAL,
    readOnly: true,
    inPrep: true,
    actions: (config: ConfigStateService) => [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.SUBMIT_FOR_REVIEW],
    snapshotName: "Preparation - Package Generated",
  };
  static WAITING_FOR_FIRST_REVIEWER: TaxReturnStatus = {
    id: 2, // waitingForReviewer1
    name: "Waiting for first review",
    step: TaxReturnStep.FIRST_REVIEW,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => config.featureFlags.preparerCanReturnBackForChanges ? [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.REVIEW] : [TaxReturnAction.REVIEW],
    snapshotName: "Ready for First Review",
  };

  static IN_FIRST_REVIEW: TaxReturnStatus = {
    id: 3, // review1
    name: "In first review",
    step: TaxReturnStep.FIRST_REVIEW,
    phase: TaxReturnPhase.ORIGINAL,
    inReview: true,
    actions: (config: ConfigStateService) => [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.REVIEW_COMPLETED, TaxReturnAction.GENERATE_TAX_PACKAGE],
    snapshotName: "First Review",
  };
  static REVIEW_1_GENERATING_TAX_RETURN: TaxReturnStatus = {
    id: 59,
    name: "Sent for package generation",
    step: TaxReturnStep.FIRST_REVIEW_WAITING_FOR_PACKAGE_GENERATION,
    phase: TaxReturnPhase.ORIGINAL,
    readOnly: true,
    actions: (config: ConfigStateService) => [],
    snapshotName: "First Review - Generating Package",
  };
  static REVIEW_1_GENERATION_COMPLETE: TaxReturnStatus = {
    id: 62,
    name: "Package generation complete",
    step: TaxReturnStep.FIRST_REVIEW_PACKAGE_GENERATED,
    phase: TaxReturnPhase.ORIGINAL,
    readOnly: true,
    actions: (config: ConfigStateService) => [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.REVIEW_COMPLETED],
    snapshotName: "First Review - Package Generated",
  };
  static WAITING_FOR_SECOND_REVIEWER: TaxReturnStatus = {
    id: 4, // waitingForReviewer2
    name: "Waiting for second review",
    step: TaxReturnStep.SECOND_REVIEW,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.REVIEW],
    snapshotName: "Ready for Second Review",
  };
  static IN_SECOND_REVIEW: TaxReturnStatus = {
    id: 5, // review2
    name: "In second review",
    step: TaxReturnStep.SECOND_REVIEW,
    phase: TaxReturnPhase.ORIGINAL,
    inReview: true,
    actions: (config: ConfigStateService) => config.tenant === Tenant.FR
      ? [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.GENERATE_FINAL_DOCUMENTS_FINAL]
      : [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.GENERATE_TAX_PACKAGE_FINAL],
    snapshotName: "Second Review",
  };
  static REVIEW_2_GENERATING_TAX_RETURN: TaxReturnStatus = {
    id: 60,
    name: "Second review - sent for package generation",
    step: TaxReturnStep.SECOND_REVIEW_WAITING_FOR_PACKAGE_GENERATION,
    phase: TaxReturnPhase.ORIGINAL,
    readOnly: true,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Second Review - Generating Package",
  };
  static REVIEW_2_GENERATION_COMPLETE: TaxReturnStatus = {
    id: 63,
    name: "Second review - package generation complete",
    step: TaxReturnStep.SECOND_REVIEW_PACKAGE_GENERATED,
    phase: TaxReturnPhase.ORIGINAL,
    readOnly: true,
    actions: (config: ConfigStateService) => {
      if(config.tenant === Tenant.JPCORP) {
        return [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.FILES_SENT_TO_CLIENT]
      }
      return [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.PREVIEW_FINAL_PACKAGE]
    },
    snapshotName: "Second Review - Package Generated",
  };
  static LINK_FAIL_UPLOAD: TaxReturnStatus = {
    id: 166,
    name: "Link fail upload",
    step: TaxReturnStep.LINK_FAIL_UPLOAD,
    phase: TaxReturnPhase.ORIGINAL,
    readOnly: true,
    actions: (config: ConfigStateService) => config.featureFlags.useSpecificStatusWhenLinkUploadFails
      ? [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.LINK_FAIL_UPLOAD_NEXT]
      : [TaxReturnAction.BACK_FOR_CHANGES],
    snapshotName: "Link Fail Upload",
  };
  static REVIEW_2_FINAL_PACKAGE_SUBMITTING: TaxReturnStatus = {
    id: 76,
    name: "Second review - final package ready",
    step: TaxReturnStep.SECOND_REVIEW_FINAL_PACKAGE_SUBMITTING,
    phase: TaxReturnPhase.ORIGINAL,
    readOnly: true,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Second Review - Submitting Final Package",
  };
  static AWAITING_TAXPAYER_APPROVAL: TaxReturnStatus = {
    id: 6, // submittedToAssignee
    name: "Awaiting taxpayer approval",
    step: TaxReturnStep.AWAITING_TAXPAYER_APPROVAL,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => {
      if(config.tenant === Tenant.HK || config.tenant === Tenant.CN){
        return [ TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.REVISE_BACK_FOR_CHANGES_SECONDARY,  TaxReturnAction.TAXPAYER_ACCEPTED_NEXT];
      }
      return [TaxReturnAction.TAXPAYER_ACCEPTED, TaxReturnAction.TAXPAYER_REJECTED];
    },
    snapshotName: "Awaiting Taxpayer Approval",
  };
  static AWAITING_EMPLOYER_APPROVAL: TaxReturnStatus = {
    id: 101, //submitted to employer
    name: "Awaiting Employer Approval",
    step: TaxReturnStep.AWAITING_EMPLOYER_APPROVAL,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => {
      if(config.tenant === Tenant.HK || config.tenant === Tenant.CN){
        return [ TaxReturnAction.EMPLOYER_REJECTED_BACK, TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.EMPLOYER_ACCEPTED_NEXT ];
      }
      return [TaxReturnAction.EMPLOYER_ACCEPTED, TaxReturnAction.EMPLOYER_REJECTED]
    },
    snapshotName: "Awaiting Employer Approval",
  };
  static AWAITING_TAXPAYER_EMPLOYER_APPROVAL: TaxReturnStatus = {
    id: 104, //submitted to employer and client
    name: "Awaiting Taxpayer and Employer Approval",
    step: TaxReturnStep.AWAITING_TAXPAYER_EMPLOYER_APPROVAL,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.TAXPAYER_EMPLOYER_ACCEPTED, TaxReturnAction.TAXPAYER_EMPLOYER_REJECTED],
    snapshotName: "Awaiting Taxpayer and  Employer Approval",
  };
  static TAXPAYER_SUBMITTED_EMPLOYER_FAILED: TaxReturnStatus = {
    id: 107, //submitted to taxpayer, but fail to send to employer
    name: "Submitted to Taxpayer / Employer Submission failed",
    step: TaxReturnStep.TAXPAYER_SUBMITTED_EMPLOYER_FAILED,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.TAXPAYER_EMPLOYER_ACCEPTED, TaxReturnAction.TAXPAYER_EMPLOYER_REJECTED, TaxReturnAction.RESUBMIT_EMPLOYER_FINAL_PACKAGE],
    snapshotName: "Submitted to Taxpayer / Employer Submission failed",
  };
  static TAXPAYER_APPROVED_EMPLOYER_FAILED: TaxReturnStatus = {
    id: 110, //submitted to taxpayer, but fail to send to employer
    name: "Taxpayer Approved / Employer Submission failed",
    step: TaxReturnStep.TAXPAYER_APPROVED_EMPLOYER_FAILED,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.EMPLOYER_ACCEPTED, TaxReturnAction.EMPLOYER_REJECTED, TaxReturnAction.RESUBMIT_EMPLOYER_FINAL_PACKAGE],
    snapshotName: "Taxpayer Approved / Employer Submission failed",
  };
  static SENT_FOR_LODGEMENT: TaxReturnStatus = {
    id: 52, // sentForLodgement
    name: "Sent for lodgement",
    step: TaxReturnStep.SENT_FOR_LODGEMENT,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => {
      if(config.tenant === Tenant.CN || config.tenant === Tenant.HK) {
        return [TaxReturnAction.LODGED_NEXT];
      }
      return [TaxReturnAction.LODGED]
    },
    snapshotName: "Sent for Lodgement",
  };
  static TAXPAYER_REJECTED: TaxReturnStatus = {
    id: 55, // assigneeRejected
    name: `${(config: ConfigStateService) => new TenantConfigService(config).config.taxReturnAlias} rejected`,
    step: TaxReturnStep.TAXPAYER_REJECTED,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.REVISE],
    snapshotName: `${(config: ConfigStateService) => new TenantConfigService(config).config.taxReturnAlias} rejected`,
  };
  static LODGED: TaxReturnStatus = {
    id: 7, // lodged
    name: "Lodged",
    step: TaxReturnStep.LODGED,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.AMEND],
    snapshotName: "Lodged",
  };
  // REVISION
  static REVISION_READY_FOR_PREPARATION: TaxReturnStatus = {
    id: 16, // waitingForRevisionPrep
    name: "Waiting for preparation (revision)",
    step: TaxReturnStep.PREPARATION,
    phase: TaxReturnPhase.REVISION,
    actions: (config: ConfigStateService) => [TaxReturnAction.PREPARE],
    snapshotName: "Ready for Preparation",
  };
  static REVISION_IN_PREPARATION: TaxReturnStatus = {
    id: 17, // revisionPrep
    name: "In preparation (revision)",
    step: TaxReturnStep.PREPARATION,
    phase: TaxReturnPhase.REVISION,
    inPrep: true,
    actions: (config: ConfigStateService) => config.tenant === Tenant.FR ? [TaxReturnAction.GENERATE_FINAL_DOCUMENTS] : [TaxReturnAction.GENERATE_TAX_PACKAGE],
    snapshotName: "Preparation",
  };
  static REVISION_PREP_GENERATING_TAX_RETURN: TaxReturnStatus = {
    id: 70,
    name: "Sent for package generation",
    step: TaxReturnStep.PREP_WAITING_FOR_PACKAGE_GENERATION,
    phase: TaxReturnPhase.REVISION,
    readOnly: true,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Preparation - Generating Package",
  };
  static REVISION_PREP_GENERATION_COMPLETE: TaxReturnStatus = {
    id: 73,
    name: "Package generation complete",
    step: TaxReturnStep.PREP_PACKAGE_GENERATED,
    phase: TaxReturnPhase.REVISION,
    readOnly: true,
    actions: (config: ConfigStateService) => [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.SUBMIT_FOR_REVIEW],
    snapshotName: "Preparation - Package Generated",
  };
  static REVISION_WAITING_FOR_FIRST_REVIEWER: TaxReturnStatus = {
    id: 18, // revisionWaitingForReviewer1
    name: "Waiting for first review (revision)",
    step: TaxReturnStep.FIRST_REVIEW,
    phase: TaxReturnPhase.REVISION,
    actions: (config: ConfigStateService) => config.featureFlags.preparerCanReturnBackForChanges ? [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.REVIEW] : [TaxReturnAction.REVIEW],
    snapshotName: "Ready for First Review",
  };
  static REVISION_IN_FIRST_REVIEW: TaxReturnStatus = {
    id: 19, // revisionReview1
    name: "In first review (revision)",
    step: TaxReturnStep.FIRST_REVIEW,
    phase: TaxReturnPhase.REVISION,
    inReview: true,
    actions: (config: ConfigStateService) => [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.REVIEW_COMPLETED],
    snapshotName: "First Review",
  };
  static REVISION_REVIEW_1_GENERATING_TAX_RETURN: TaxReturnStatus = {
    id: 71,
    name: "First review - sent for package generation (revision)",
    step: TaxReturnStep.FIRST_REVIEW_WAITING_FOR_PACKAGE_GENERATION,
    phase: TaxReturnPhase.REVISION,
    readOnly: true,
    actions: (config: ConfigStateService) => [],
    snapshotName: "First Review - Generating Package",
  };
  static REVISION_REVIEW_1_GENERATION_COMPLETE: TaxReturnStatus = {
    id: 74,
    name: "First review - package generation complete (revision)",
    step: TaxReturnStep.FIRST_REVIEW_PACKAGE_GENERATED,
    phase: TaxReturnPhase.REVISION,
    readOnly: true,
    actions: (config: ConfigStateService) => [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.REVIEW_COMPLETED],
    snapshotName: "First Review - Package Generated",
  };
  static REVISION_WAITING_FOR_SECOND_REVIEWER: TaxReturnStatus = {
    id: 20, // revisionWaitingForReviewer2
    name: "Waiting for second review (revision)",
    step: TaxReturnStep.SECOND_REVIEW,
    phase: TaxReturnPhase.REVISION,
    actions: (config: ConfigStateService) => [TaxReturnAction.REVIEW],
    snapshotName: "Ready for Second Review",
  };
  static REVISION_IN_SECOND_REVIEW: TaxReturnStatus = {
    id: 21, // revisionReview2
    name: "In second review (revision)",
    step: TaxReturnStep.SECOND_REVIEW,
    phase: TaxReturnPhase.REVISION,
    inReview: true,
    actions: (config: ConfigStateService) => config.tenant === Tenant.FR
      ? [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.GENERATE_FINAL_DOCUMENTS_FINAL]
      : [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.GENERATE_TAX_PACKAGE_FINAL],
    snapshotName: "Second Review",
  };
  static REVISION_REVIEW_2_GENERATING_TAX_RETURN: TaxReturnStatus = {
    id: 72,
    name: "Second review - sent for package generation (revision)",
    step: TaxReturnStep.SECOND_REVIEW_WAITING_FOR_PACKAGE_GENERATION,
    phase: TaxReturnPhase.REVISION,
    readOnly: true,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Second Review - Generating Package",
  };
  static REVISION_REVIEW_2_GENERATION_COMPLETE: TaxReturnStatus = {
    id: 75,
    name: "Second review - package generation complete (revision)",
    step: TaxReturnStep.SECOND_REVIEW_PACKAGE_GENERATED,
    phase: TaxReturnPhase.REVISION,
    readOnly: true,
    actions: (config: ConfigStateService) => {
      if(config.tenant === Tenant.JPCORP) {
        return [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.FILES_SENT_TO_CLIENT]
      }
      return [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.PREVIEW_FINAL_PACKAGE]
    },
    snapshotName: "Second Review - Package Generated",
  };
  static REVISION_LINK_FAIL_UPLOAD: TaxReturnStatus = {
    id: 168,
    name: "Link fail upload (revision)",
    step: TaxReturnStep.LINK_FAIL_UPLOAD,
    phase: TaxReturnPhase.REVISION,
    readOnly: true,
    actions: (config: ConfigStateService) => config.featureFlags.useSpecificStatusWhenLinkUploadFails
      ? [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.LINK_FAIL_UPLOAD_NEXT]
      : [TaxReturnAction.BACK_FOR_CHANGES],
    snapshotName: "Link Fail Upload",
  };
  static REVISION_REVIEW_2_FINAL_PACKAGE_SUBMITTING: TaxReturnStatus = {
    id: 78,
    name: "Second review - final package ready (revision)",
    step: TaxReturnStep.SECOND_REVIEW_FINAL_PACKAGE_SUBMITTING,
    phase: TaxReturnPhase.REVISION,
    readOnly: true,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Second Review - Submitting Final Package",
  };
  static REVISION_AWAITING_TAXPAYER_APPROVAL: TaxReturnStatus = {
    id: 22, // revisionSubmittedToAssignee
    name: "Awaiting taxpayer approval (revision)",
    step: TaxReturnStep.AWAITING_TAXPAYER_APPROVAL,
    phase: TaxReturnPhase.REVISION,
    actions: (config: ConfigStateService) => {
      if(config.tenant === Tenant.HK || config.tenant === Tenant.CN){
        return [  TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.REVISE_BACK_FOR_CHANGES_SECONDARY,  TaxReturnAction.TAXPAYER_ACCEPTED_NEXT];
      }
      return [TaxReturnAction.TAXPAYER_ACCEPTED, TaxReturnAction.TAXPAYER_REJECTED]
    },
    snapshotName: "Awaiting Taxpayer Approval",
  };
  static REVISION_AWAITING_EMPLOYER_APPROVAL: TaxReturnStatus = {
    id: 103, // revisionSubmittedToAssignee
    name: "Awaiting employer approval (revision)",
    step: TaxReturnStep.AWAITING_EMPLOYER_APPROVAL,
    phase: TaxReturnPhase.REVISION,
    actions: (config: ConfigStateService) => {
      if(config.tenant === Tenant.HK || config.tenant === Tenant.CN){
        return [ TaxReturnAction.EMPLOYER_REJECTED_BACK, TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.EMPLOYER_ACCEPTED_NEXT];
      }
      return [TaxReturnAction.EMPLOYER_ACCEPTED, TaxReturnAction.EMPLOYER_REJECTED]
    },    snapshotName: "Awaiting Employer Approval",
  };
  static REVISION_AWAITING_TAXPAYER_EMPLOYER_APPROVAL: TaxReturnStatus = {
    id: 106, // revisionSubmittedToAssignee
    name: "Awaiting taxpayer and employer approval (revision)",
    step: TaxReturnStep.AWAITING_TAXPAYER_EMPLOYER_APPROVAL,
    phase: TaxReturnPhase.REVISION,
    actions: (config: ConfigStateService) => [TaxReturnAction.TAXPAYER_EMPLOYER_ACCEPTED, TaxReturnAction.TAXPAYER_EMPLOYER_REJECTED],
    snapshotName: "Awaiting Taxpayer and Employer Approval",
  };
  static REVISION_TAXPAYER_SUBMITTED_EMPLOYER_FAILED: TaxReturnStatus = {
    id: 109, // final package sent to taxpayer, but failed to sent to employer
    name: "Submitted to Taxpayer / Employer Submission failed  (revision)",
    step: TaxReturnStep.TAXPAYER_SUBMITTED_EMPLOYER_FAILED,
    phase: TaxReturnPhase.REVISION,
    actions: (config: ConfigStateService) => [TaxReturnAction.TAXPAYER_EMPLOYER_ACCEPTED, TaxReturnAction.TAXPAYER_EMPLOYER_REJECTED, TaxReturnAction.RESUBMIT_EMPLOYER_FINAL_PACKAGE],
    snapshotName: "Submitted to Taxpayer / Employer Submission failed",
  };

  static REVISION_TAXPAYER_APPROVED_EMPLOYER_FAILED: TaxReturnStatus = {
    id: 112, // taxpayer approved, but fail to send to employer
    name: "Taxpayer Approved / Employer Submission failed  (revision)",
    step: TaxReturnStep.TAXPAYER_APPROVED_EMPLOYER_FAILED,
    phase: TaxReturnPhase.REVISION,
    actions: (config: ConfigStateService) => [TaxReturnAction.EMPLOYER_ACCEPTED, TaxReturnAction.EMPLOYER_REJECTED, TaxReturnAction.RESUBMIT_EMPLOYER_FINAL_PACKAGE],
    snapshotName: "Taxpayer Approved / Employer Submission failed",
  };
  static REVISION_SENT_FOR_LODGEMENT: TaxReturnStatus = {
    id: 54, // revisionSentForLodgement
    name: "Sent for lodgement",
    step: TaxReturnStep.SENT_FOR_LODGEMENT,
    phase: TaxReturnPhase.REVISION,
    actions: (config: ConfigStateService) => {
      if(config.tenant === Tenant.CN || config.tenant === Tenant.HK) {
        return [TaxReturnAction.LODGED_NEXT];
      }
      return [TaxReturnAction.LODGED]
    },
    snapshotName: "Sent for Lodgement",
  };
  static REVISION_TAXPAYER_REJECTED: TaxReturnStatus = {
    id: 57, // revisionAssigneeRejected
    name: `${(config: ConfigStateService) => new TenantConfigService(config).config.taxReturnAlias} rejected (revision)`,
    step: TaxReturnStep.TAXPAYER_REJECTED,
    phase: TaxReturnPhase.REVISION,
    actions: (config: ConfigStateService) => [TaxReturnAction.REVISE],
    snapshotName: `${(config: ConfigStateService) => new TenantConfigService(config).config.taxReturnAlias} rejected`,
  };
  static REVISION_LODGED: TaxReturnStatus = {
    id: 23, // lodged
    name: "Lodged (revision)",
    step: TaxReturnStep.LODGED,
    phase: TaxReturnPhase.REVISION,
    actions: (config: ConfigStateService) => [TaxReturnAction.AMEND],
    snapshotName: "Lodged",
  };

  // AMENDMENT
  static AMENDMENT_READY_FOR_PREPARATION: TaxReturnStatus = {
    id: 8, // waitingForAmendmentPrep
    name: "Waiting for preparation (amendment)",
    step: TaxReturnStep.PREPARATION,
    phase: TaxReturnPhase.AMENDMENT,
    actions: (config: ConfigStateService) => [TaxReturnAction.PREPARE],
    snapshotName: "Ready for Preparation",
  };
  static AMENDMENT_IN_PREPARATION: TaxReturnStatus = {
    id: 9, // amendmentPrep
    name: "In preparation (amendment)",
    step: TaxReturnStep.PREPARATION,
    phase: TaxReturnPhase.AMENDMENT,
    inPrep: true,
    actions: (config: ConfigStateService) => config.tenant === Tenant.FR ? [TaxReturnAction.GENERATE_FINAL_DOCUMENTS] : [TaxReturnAction.GENERATE_TAX_PACKAGE],
    snapshotName: "Preparation",
  };
  static AMENDMENT_PREP_GENERATING_TAX_RETURN: TaxReturnStatus = {
    id: 64,
    name: "Sent for package generation",
    step: TaxReturnStep.PREP_WAITING_FOR_PACKAGE_GENERATION,
    phase: TaxReturnPhase.AMENDMENT,
    readOnly: true,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Preparation - Generating Package",
  };
  static AMENDMENT_PREP_GENERATION_COMPLETE: TaxReturnStatus = {
    id: 67,
    name: "Package generation complete",
    step: TaxReturnStep.PREP_PACKAGE_GENERATED,
    phase: TaxReturnPhase.AMENDMENT,
    readOnly: true,
    actions: (config: ConfigStateService) => [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.SUBMIT_FOR_REVIEW],
    snapshotName: "Preparation - Package Generated",
  };
  static AMENDMENT_WAITING_FOR_FIRST_REVIEWER: TaxReturnStatus = {
    id: 10, // amendmentWaitingForReviewer1
    name: "Waiting for first review (amendment)",
    step: TaxReturnStep.FIRST_REVIEW,
    phase: TaxReturnPhase.AMENDMENT,
    actions: (config: ConfigStateService) => config.featureFlags.preparerCanReturnBackForChanges ? [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.REVIEW] : [TaxReturnAction.REVIEW],
    snapshotName: "Ready for First Review",
  };
  static AMENDMENT_IN_FIRST_REVIEW: TaxReturnStatus = {
    id: 11, // amendmentReview1
    name: "In first review (amendment)",
    step: TaxReturnStep.FIRST_REVIEW,
    phase: TaxReturnPhase.AMENDMENT,
    inReview: true,
    actions: (config: ConfigStateService) => [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.REVIEW_COMPLETED],
    snapshotName: "First Review",
  };
  static AMENDMENT_REVIEW_1_GENERATING_TAX_RETURN: TaxReturnStatus = {
    id: 65,
    name: "Sent for package generation",
    step: TaxReturnStep.FIRST_REVIEW_WAITING_FOR_PACKAGE_GENERATION,
    phase: TaxReturnPhase.AMENDMENT,
    readOnly: true,
    actions: (config: ConfigStateService) => [],
    snapshotName: "First Review - Generating Package",
  };
  static AMENDMENT_REVIEW_1_GENERATION_COMPLETE: TaxReturnStatus = {
    id: 68,
    name: "Package generation complete",
    step: TaxReturnStep.FIRST_REVIEW_PACKAGE_GENERATED,
    phase: TaxReturnPhase.AMENDMENT,
    readOnly: true,
    actions: (config: ConfigStateService) => [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.REVIEW_COMPLETED],
    snapshotName: "First Review - Package Generated",
  };
  static AMENDMENT_WAITING_FOR_SECOND_REVIEWER: TaxReturnStatus = {
    id: 12, // amendmentWaitingForReviewer2
    name: "Waiting for second review (amendment)",
    step: TaxReturnStep.SECOND_REVIEW,
    phase: TaxReturnPhase.AMENDMENT,
    actions: (config: ConfigStateService) => [TaxReturnAction.REVIEW],
    snapshotName: "Ready for Second Review",
  };
  static AMENDMENT_IN_SECOND_REVIEW: TaxReturnStatus = {
    id: 13, // amendmentReview2
    name: "In second review (amendment)",
    step: TaxReturnStep.SECOND_REVIEW,
    phase: TaxReturnPhase.AMENDMENT,
    inReview: true,
    actions: (config: ConfigStateService) => config.tenant === Tenant.FR
      ? [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.GENERATE_FINAL_DOCUMENTS_FINAL]
      : [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.GENERATE_TAX_PACKAGE_FINAL],
    snapshotName: "Second Review",
  };
  static AMENDMENT_REVIEW_2_GENERATING_TAX_RETURN: TaxReturnStatus = {
    id: 66,
    name: "Second review - sent for package generation (amendment)",
    step: TaxReturnStep.SECOND_REVIEW_WAITING_FOR_PACKAGE_GENERATION,
    phase: TaxReturnPhase.AMENDMENT,
    readOnly: true,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Second Review - Generating Package",
  };
  static AMENDMENT_REVIEW_2_GENERATION_COMPLETE: TaxReturnStatus = {
    id: 69,
    name: "Second review - package generation complete (amendment)",
    step: TaxReturnStep.SECOND_REVIEW_PACKAGE_GENERATED,
    phase: TaxReturnPhase.AMENDMENT,
    readOnly: true,
    actions: (config: ConfigStateService) => {
      if(config.tenant === Tenant.JPCORP) {
        return [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.FILES_SENT_TO_CLIENT]
      }
      return [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.PREVIEW_FINAL_PACKAGE]
    },
    snapshotName: "Second Review - Package Generated",
  };
  static AMENDMENT_LINK_FAIL_UPLOAD: TaxReturnStatus = {
    id: 167,
    name: "Link fail upload (amendment)",
    step: TaxReturnStep.LINK_FAIL_UPLOAD,
    phase: TaxReturnPhase.AMENDMENT,
    readOnly: true,
    actions: (config: ConfigStateService) => config.featureFlags.useSpecificStatusWhenLinkUploadFails
      ? [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.LINK_FAIL_UPLOAD_NEXT]
      : [TaxReturnAction.BACK_FOR_CHANGES],
    snapshotName: "Link Fail Upload",
  };
  static AMENDMENT_REVIEW_2_FINAL_PACKAGE_SUBMITTING: TaxReturnStatus = {
    id: 77,
    name: "Second review - final package ready (amendment)",
    step: TaxReturnStep.SECOND_REVIEW_FINAL_PACKAGE_SUBMITTING,
    phase: TaxReturnPhase.AMENDMENT,
    readOnly: true,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Second Review - Submitting Final Package",
  };
  static AMENDMENT_AWAITING_TAXPAYER_APPROVAL: TaxReturnStatus = {
    id: 14, // amendmentSubmittedToAssignee
    name: "Awaiting taxpayer approval (amendment)",
    step: TaxReturnStep.AWAITING_TAXPAYER_APPROVAL,
    phase: TaxReturnPhase.AMENDMENT,
    actions: (config: ConfigStateService) => {
      if(config.tenant === Tenant.HK || config.tenant === Tenant.CN){
        return [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.REVISE_BACK_FOR_CHANGES_SECONDARY,  TaxReturnAction.TAXPAYER_ACCEPTED_NEXT];
      }
      return [TaxReturnAction.TAXPAYER_ACCEPTED, TaxReturnAction.TAXPAYER_REJECTED]
    },
    snapshotName: "Awaiting Taxpayer Approval",
  };
  static AMENDMENT_AWAITING_EMPLOYER_APPROVAL: TaxReturnStatus = {
    id: 102, // amendmentSubmittedToAssignee
    name: "Awaiting employer approval (amendment)",
    step: TaxReturnStep.AWAITING_EMPLOYER_APPROVAL,
    phase: TaxReturnPhase.AMENDMENT,
    actions: (config: ConfigStateService) => {
      if(config.tenant === Tenant.HK || config.tenant === Tenant.CN){
        return [TaxReturnAction.EMPLOYER_REJECTED_BACK, TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.EMPLOYER_ACCEPTED_NEXT];
      }
      return [TaxReturnAction.EMPLOYER_ACCEPTED, TaxReturnAction.EMPLOYER_REJECTED]
    },    snapshotName: "Awaiting Employer Approval",
  };
  static AMENDMENT_AWAITING_TAXPAYER_EMPLOYER_APPROVAL: TaxReturnStatus = {
    id: 105, // revisionSubmittedToAssignee
    name: "Awaiting taxpayer and employer approval (amendment)",
    step: TaxReturnStep.AWAITING_TAXPAYER_EMPLOYER_APPROVAL,
    phase: TaxReturnPhase.AMENDMENT,
    actions: (config: ConfigStateService) => [TaxReturnAction.TAXPAYER_EMPLOYER_ACCEPTED, TaxReturnAction.TAXPAYER_EMPLOYER_REJECTED],
    snapshotName: "Awaiting Taxpayer and Employer Approval",
  };
  static AMENDMENT_TAXPAYER_SUBMITTED_EMPLOYER_FAILED: TaxReturnStatus = {
    id: 108, // revisionSubmittedToAssignee
    name: "Submitted to Taxpayer / Employer Failed (amendment)",
    step: TaxReturnStep.TAXPAYER_SUBMITTED_EMPLOYER_FAILED,
    phase: TaxReturnPhase.AMENDMENT,
    actions: (config: ConfigStateService) => [TaxReturnAction.TAXPAYER_EMPLOYER_ACCEPTED, TaxReturnAction.TAXPAYER_EMPLOYER_REJECTED, TaxReturnAction.RESUBMIT_EMPLOYER_FINAL_PACKAGE],
    snapshotName: "Submitted to Taxpayer / Employer Failed",
  };
  static AMENDMENT_TAXPAYER_APPROVED_EMPLOYER_FAILED: TaxReturnStatus = {
    id: 111, //submitted to taxpayer, but fail to send to employer
    name: "Taxpayer Approved / Employer Submission failed  (amendment)",
    step: TaxReturnStep.TAXPAYER_APPROVED_EMPLOYER_FAILED,
    phase: TaxReturnPhase.AMENDMENT,
    actions: (config: ConfigStateService) => [TaxReturnAction.EMPLOYER_ACCEPTED, TaxReturnAction.EMPLOYER_REJECTED, TaxReturnAction.RESUBMIT_EMPLOYER_FINAL_PACKAGE],
    snapshotName: "Taxpayer Approved / Employer Submission failed",
  };
  static AMENDMENT_SENT_FOR_LODGEMENT: TaxReturnStatus = {
    id: 53, // amendmentSentForLodgement
    name: "Sent for lodgement",
    step: TaxReturnStep.SENT_FOR_LODGEMENT,
    phase: TaxReturnPhase.AMENDMENT,
    actions: (config: ConfigStateService) => {
      if(config.tenant === Tenant.CN || config.tenant === Tenant.HK) {
        return [TaxReturnAction.LODGED_NEXT];
      }
      return [TaxReturnAction.LODGED]
    },
    snapshotName: "Sent for Lodgement",
  };
  static AMENDMENT_TAXPAYER_REJECTED: TaxReturnStatus = {
    id: 56, // amendmentAssigneeRejected
    name: `${(config: ConfigStateService) => new TenantConfigService(config).config.taxReturnAlias} rejected (amendment)`,
    step: TaxReturnStep.TAXPAYER_REJECTED,
    phase: TaxReturnPhase.AMENDMENT,
    actions: (config: ConfigStateService) => [TaxReturnAction.REVISE],
    snapshotName: `${(config: ConfigStateService) => new TenantConfigService(config).config.taxReturnAlias} rejected`,
  };
  static AMENDMENT_LODGED: TaxReturnStatus = {
    id: 15, // lodged
    name: "Lodged (amendment)",
    step: TaxReturnStep.LODGED,
    phase: TaxReturnPhase.AMENDMENT,
    actions: (config: ConfigStateService) => [TaxReturnAction.AMEND],
    snapshotName: "Lodged",
  };
  static CHECKING_FOR_PREFILL: TaxReturnStatus = {
    id: 114, // lodged
    name: "Checking For Prefill",
    step: TaxReturnStep.CHECKING_FOR_PREFILL,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Checking For Prefill",
  };
  static PREFILL_LOAD_FAILED: TaxReturnStatus = {
    id: 115, // lodged
    name: "Prefill Load Failed",
    step: TaxReturnStep.PREFILL_LOAD_FAILED,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Prefill Load Failed",
  };
  static READY_TO_RUN_CALCS_SQNR: TaxReturnStatus = {
    id: 116, // lodged
    name: "Ready to run calcs ( SQNR )",
    step: TaxReturnStep.READY_TO_RUN_CALCS_SQNR,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [],
    snapshotName: "Ready to run calcs ( SQNR )",
  };
  static ELECTRONIC_PACKAGE_SENT_TAXPAYER_TO_LODGE: TaxReturnStatus = {
    id: 130, //electronicPackageSentAssigneeToLodge
    name:"Electronic Package Sent: TP to Lodge",
    step: TaxReturnStep.ELECTRONIC_PACKAGE_SENT_TAXPAYER_TO_LODGE,
    phase: TaxReturnPhase.ORIGINAL,
    actions:(config: ConfigStateService) => [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.AMEND, TaxReturnAction.REVISE_BACK_FOR_CHANGES],
    readOnly: true,
    snapshotName: "Electronic Package Sent: TP to Lodge",
    };
    static SENT_FOR_PRINTING: TaxReturnStatus = {
    id: 131, //sentForPrinting
    name:"Sent for Printing",
    step: TaxReturnStep.SENT_FOR_PRINTING,
    phase: TaxReturnPhase.ORIGINAL,
    actions:(config: ConfigStateService) => [TaxReturnAction.INFORMATION_NOT_COMPLETE, TaxReturnAction.CHECK_PRINTED_PACKAGE_NEXT],
    readOnly: true,
    snapshotName: "Sent for Printing",
    };
    static ELECTRONIC_PACKAGE_SENT_TAXPAYER_TO_LODGE_REVISION: TaxReturnStatus = {
    id: 132, //revisionElectronicPackageSentAssigneeToLodge
    name:"Electronic Package Sent: TP to Lodge (Revision)",
    step: TaxReturnStep.ELECTRONIC_PACKAGE_SENT_TAXPAYER_TO_LODGE,
    phase: TaxReturnPhase.REVISION,
    actions:(config: ConfigStateService) => [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.AMEND, TaxReturnAction.REVISE_BACK_FOR_CHANGES],
    readOnly: true,
    snapshotName: "Electronic Package Sent: TP to Lodge (Revision)",
    };
    static ELECTRONIC_PACKAGE_SENT_TAXPAYER_TO_LODGE_AMENDMENT: TaxReturnStatus = {
    id: 133, //amendmentElectronicPackageSentAssigneeToLodge
    name:"Electronic Package Sent: TP to Lodge (Amendment)",
    step: TaxReturnStep.ELECTRONIC_PACKAGE_SENT_TAXPAYER_TO_LODGE,
    phase: TaxReturnPhase.AMENDMENT,
    actions:(config: ConfigStateService) => [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.AMEND, TaxReturnAction.REVISE_BACK_FOR_CHANGES],
    readOnly: true,
    snapshotName: "Electronic Package Sent: TP to Lodge (Amendment)",
    };
    static ELECTRONIC_PACKAGE_SENT_CLIENT_TO_LODGE: TaxReturnStatus = {
    id: 134, //electronicPackageSentClientToLodge
    name:"Electronic Package: Sent: Client to Lodge",
    step: TaxReturnStep.ELECTRONIC_PACKAGE_SENT_CLIENT_TO_LODGE,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => {
      if (config.tenant === Tenant.CN) {
        return [ TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.REVISE_BACK_FOR_CHANGES_SECONDARY];
      }
      return [TaxReturnAction.TAXPAYER_ACCEPTED, TaxReturnAction.TAXPAYER_REJECTED];
    },
    readOnly: true,
    snapshotName: "Electronic Package: Sent: Client to Lodge",
    };
    static ELECTRONIC_PACKAGE_SENT_CLIENT_TO_LODGE_REVISION: TaxReturnStatus = {
    id: 135, //revisionElectronicPackageSentClientToLodge
    name:"Electronic Package: Sent: Client to Lodge (Revision)",
    step: TaxReturnStep.ELECTRONIC_PACKAGE_SENT_CLIENT_TO_LODGE,
    phase: TaxReturnPhase.REVISION,
    actions:(config: ConfigStateService) => [],
    readOnly: true,
    snapshotName: "Electronic Package: Sent: Client to Lodge (Revision)",
    };
    static ELECTRONIC_PACKAGE_SENT_CLIENT_TO_LODGE_AMENDMENT: TaxReturnStatus = {
    id: 136, //amendmentPackageSentClientToLodge
    name:"Electronic Package: Sent: Client to Lodge (Amendment)",
    step: TaxReturnStep.ELECTRONIC_PACKAGE_SENT_CLIENT_TO_LODGE,
    phase: TaxReturnPhase.AMENDMENT,
    actions:(config: ConfigStateService) => [],
    readOnly: true,
    snapshotName: "Electronic Package: Sent: Client to Lodge (Amendment)",
    };
    static AWAITING_EXCEPTION_FILING: TaxReturnStatus = {
    id: 137, //awaitingExceptionFiling
    name:"Awaiting Exception Filing",
    step: TaxReturnStep.EXEPTION_FILING_AWAITING,
    phase: TaxReturnPhase.ORIGINAL,
    actions:(config: ConfigStateService) => [ TaxReturnAction.QUESTION_DRIVEN_STATUS],
    readOnly: true,
    snapshotName: "Awaiting Exception Filing",
    };
    static AWAITING_EXCEPTION_FILING_REVISION: TaxReturnStatus = {
    id: 138, //revisionAwaitingExceptionFiling
    name:"Awaiting Exception Filing (Revision)",
    step: TaxReturnStep.EXEPTION_FILING_AWAITING,
    phase: TaxReturnPhase.REVISION,
    actions:(config: ConfigStateService) => [ TaxReturnAction.QUESTION_DRIVEN_STATUS],
    readOnly: true,
    snapshotName: "Awaiting Exception Filing (Revision)",
    };
    static AWAITING_EXCEPTION_FILING_AMENDMENT: TaxReturnStatus = {
    id: 139, //amendmentAwaitingExceptionFiling
    name:"Awaiting Exception Filing (Amendment)",
    step: TaxReturnStep.EXEPTION_FILING_AWAITING,
    phase: TaxReturnPhase.AMENDMENT,
    actions:(config: ConfigStateService) => [ TaxReturnAction.QUESTION_DRIVEN_STATUS],
    readOnly: true,
    snapshotName: "Awaiting Exception Filing (Amendment)",
    };
    static PRINTED_PACKAGE_WAITING_FOR_CHECKING: TaxReturnStatus = {
    id: 140, //printedPackageWaitingForChecking
    name:"Printed Package: Waiting For Checking",
    step: TaxReturnStep.PRINTED_PACKAGE_WAITING_FOR_CHECKING,
    phase: TaxReturnPhase.ORIGINAL,
    actions:(config: ConfigStateService) => [TaxReturnAction.PRINTED_PACKAGE_READY_TO_SEND, TaxReturnAction.SEND_FOR_PRINTING_REFINE],
    readOnly: true,
    snapshotName: "Printed Package: Waiting For Checking",
    };
    static PRINTED_PACKAGE_READY_TO_SEND: TaxReturnStatus = {
    id: 141, //printedPackageReadyToSend
    name:"Printed Package: Ready to Send",
    step: TaxReturnStep.READY_TO_SEND,
    phase: TaxReturnPhase.ORIGINAL,
    actions:(config: ConfigStateService) => [TaxReturnAction.QUESTION_DRIVEN_STATUS],
    readOnly: true,
    snapshotName: "Printed Package: Ready to Send",
    };
    static LODGEMENT_IN_PROGRESS: TaxReturnStatus = {
    id: 142, //lodgementInProgress
    name:"Lodgement in Progress",
    step: TaxReturnStep.LODGEMENT_IN_PROGRESS,
    phase: TaxReturnPhase.ORIGINAL,
    actions:(config: ConfigStateService) => [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.LODGED_NEXT_LODGED],
    readOnly: true,
    snapshotName: "Lodgement in Progress",
    };
    static LODGEMENT_IN_PROGRESS_REVISION: TaxReturnStatus = {
    id: 143, //revisionLodgementInProgress
    name:"Lodgement in Progress (Revision)",
    step: TaxReturnStep.LODGEMENT_IN_PROGRESS,
    phase: TaxReturnPhase.REVISION,
    actions:(config: ConfigStateService) => [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.LODGED_NEXT_LODGED],
    readOnly: true,
    snapshotName: "Lodgement in Progress (Revision)",
    };
    static LODGEMENT_IN_PROGRESS_AMENDMENT: TaxReturnStatus = {
    id: 144, //amendmentLodementInProgress
    name:"Lodgement in Progress (Amendment)",
    step: TaxReturnStep.LODGEMENT_IN_PROGRESS,
    phase: TaxReturnPhase.AMENDMENT,
    actions:(config: ConfigStateService) => [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.LODGED_NEXT_LODGED],
    readOnly: true,
    snapshotName: "Lodgement in Progress (Amendment)",
    };
    static PHYSICAL_PACKAGE_SENT_CLIENT_TO_LODGE: TaxReturnStatus = {
    id: 145, //physicalPackageSentClientToLodge
    name:"Physical Package Sent: Client to Lodge",
    step: TaxReturnStep.PHYSICAL_PACKAGE_SENT_CLIENT_TO_LODGE,
    phase: TaxReturnPhase.ORIGINAL,
    actions:(config: ConfigStateService) => [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.AMEND, TaxReturnAction.REVISE_BACK_FOR_CHANGES],
    readOnly: true,
    snapshotName: "Physical Package Sent: Client to Lodge",
    };
    static PHYSICAL_PACKAGE_SENT_CLIENT_TO_RETURN_TO_KPMG: TaxReturnStatus = {
    id: 146, //physicalPackageSentClientToReturnToKPMG
    name:"Physical Package Sent: Client to Return to KPMG",
    step: TaxReturnStep.PHYSICAL_PACKAGE_SENT_CLIENT_TO_RETURN_TO_KPMG,
    phase: TaxReturnPhase.ORIGINAL,
    actions:(config: ConfigStateService) => [TaxReturnAction.REVISE_BACK_FOR_CHANGES, TaxReturnAction.TAXPAYER_ACCEPTED_NEXT],
    readOnly: true,
    snapshotName: "Physical Package Sent: Client to Return to KPMG",
    };
    static PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_LODGE: TaxReturnStatus = {
    id: 147, //physicalPackageSentTaxpayerToLodge
    name:"Physical Package Sent: TP to Lodge",
    step: TaxReturnStep.PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_LODGE,
    phase: TaxReturnPhase.ORIGINAL,
    actions:(config: ConfigStateService) => [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.AMEND, TaxReturnAction.REVISE_BACK_FOR_CHANGES],
    readOnly: true,
    snapshotName: "Physical Package Sent: TP to Lodge",
    };
    static PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_RETURN_TO_KPMG: TaxReturnStatus = {
    id: 148, //physicalPackageSentTaxpayerToReturnToKPMG
    name:"Physical Package Sent: TP to Return to KPMG",
    step: TaxReturnStep.PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_RETURN_TO_KPMG,
    phase: TaxReturnPhase.ORIGINAL,
    actions:(config: ConfigStateService) => [TaxReturnAction.REVISE_BACK_FOR_CHANGES, TaxReturnAction.TAXPAYER_ACCEPTED_NEXT],
    readOnly: true,
    snapshotName: "Physical Package Sent: TP to Return to KPMG",
    };
    static SENT_FOR_PRINTING_INFORMATION_NOT_COMPLETE: TaxReturnStatus = {
    id: 149, //sentForPrintingInformationNotComplete
    name:"Sent for Printing: Information Not Complete",
    step: TaxReturnStep.INFORMATION_NOT_COMPLETE,
    phase: TaxReturnPhase.ORIGINAL,
    actions:(config: ConfigStateService) => [TaxReturnAction.SEND_FOR_PRINTING],
    readOnly: true,
    snapshotName: "Sent for Printing: Information Not Complete",
    };
    static SENT_FOR_PRINTING_REVISION: TaxReturnStatus = {
    id: 150, //revisionSentForPrinting
    name:"Sent For Printing (Revision)",
    step: TaxReturnStep.SENT_FOR_PRINTING,
    phase: TaxReturnPhase.REVISION,
    actions:(config: ConfigStateService) => [TaxReturnAction.INFORMATION_NOT_COMPLETE, TaxReturnAction.CHECK_PRINTED_PACKAGE_NEXT],
    readOnly: true,
    snapshotName: "Sent For Printing (Revision)",
    };
    static SENT_FOR_PRINTING_INFORMATION_NOT_COMPLETE_REVISION: TaxReturnStatus = {
    id: 151, //revisionSentForPrintingInformationNotComplete
    name:"Sent for Printing: Information not Complete (Revision)",
    step: TaxReturnStep.INFORMATION_NOT_COMPLETE,
    phase: TaxReturnPhase.REVISION,
    actions:(config: ConfigStateService) => [TaxReturnAction.SEND_FOR_PRINTING],
    readOnly: true,
    snapshotName: "Sent for Printing: Information not Complete (Revision)",
    };
    static PRINTED_PACKAGE_WAITING_FOR_CHECKING_REVISION: TaxReturnStatus = {
    id: 152, //revisionPrintedPackageWaitingForChecking
    name:"Printed Package Waiting for Checking (Revision)",
    step: TaxReturnStep.PRINTED_PACKAGE_WAITING_FOR_CHECKING,
    phase: TaxReturnPhase.REVISION,
    actions:(config: ConfigStateService) => [TaxReturnAction.PRINTED_PACKAGE_READY_TO_SEND, TaxReturnAction.SEND_FOR_PRINTING_REFINE],
    readOnly: true,
    snapshotName: "Printed Package Waiting for Checking (Revision)",
    };
    static PRINTED_PACKAGE_READY_TO_SEND_REVISION: TaxReturnStatus = {
    id: 153, //revisionPrintedPackageReadyToSend
    name:"Printed Package: Ready to Send (Revision)",
    step: TaxReturnStep.READY_TO_SEND,
    phase: TaxReturnPhase.REVISION,
    actions:(config: ConfigStateService) => [TaxReturnAction.QUESTION_DRIVEN_STATUS],
    readOnly: true,
    snapshotName: "Printed Package: Ready to Send (Revision)",
    };
    static PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_LODGE_REVISION: TaxReturnStatus = {
    id: 154, //revisionPhysicalPackageSentTaxpayerToLodge
    name:"Physical Package Sent: TP to Lodge (Revision)",
    step: TaxReturnStep.PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_LODGE,
    phase: TaxReturnPhase.REVISION,
    actions:(config: ConfigStateService) => [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.AMEND, TaxReturnAction.REVISE_BACK_FOR_CHANGES],
    readOnly: true,
    snapshotName: "Physical Package Sent: TP to Lodge (Revision)",
    };
    static PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_RETURN_TO_KPMG_REVISION: TaxReturnStatus = {
    id: 155, //revisionPhysicalPackageSentTaxpayerToReturnToKPMG
    name:"Physical Package Sent: TP to Return to KPMG (Revision)",
    step: TaxReturnStep.PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_RETURN_TO_KPMG,
    phase: TaxReturnPhase.REVISION,
    actions:(config: ConfigStateService) => [TaxReturnAction.REVISE_BACK_FOR_CHANGES, TaxReturnAction.TAXPAYER_ACCEPTED_NEXT],
    readOnly: true,
    snapshotName: "Physical Package Sent: TP to Return to KPMG (Revision)",
    };
    static SENT_FOR_PRINTING_AMENDMENT: TaxReturnStatus = {
    id: 156, //amendmentSentForPrinting
    name:"Sent For Printing (Amendment)",
    step: TaxReturnStep.SENT_FOR_PRINTING,
    phase: TaxReturnPhase.AMENDMENT,
    actions:(config: ConfigStateService) => [TaxReturnAction.INFORMATION_NOT_COMPLETE, TaxReturnAction.CHECK_PRINTED_PACKAGE_NEXT],
    readOnly: true,
    snapshotName: "Sent For Printing (Amendment)",
    };
    static SENT_FOR_PRINTING_INFORMATION_NOT_COMPLETE_AMENDMENT: TaxReturnStatus = {
    id: 157, //amendmentSentForPrintingInformationNotComplete
    name:"Sent for Printing: Information not Complete (Amendment)",
    step: TaxReturnStep.INFORMATION_NOT_COMPLETE,
    phase: TaxReturnPhase.AMENDMENT,
    actions:(config: ConfigStateService) => [TaxReturnAction.SEND_FOR_PRINTING],
    readOnly: true,
    snapshotName: "Sent for Printing: Information not Complete (Amendment)",
    };
    static PRINTED_PACKAGE_WAITING_FOR_CHECKING_AMENDMENT: TaxReturnStatus = {
    id: 158, //amendmentPrintedPackageWaitingForChecking
    name:"Printed Package Waiting for Checking (Amendment)",
    step: TaxReturnStep.PRINTED_PACKAGE_WAITING_FOR_CHECKING,
    phase: TaxReturnPhase.AMENDMENT,
    actions:(config: ConfigStateService) => [TaxReturnAction.PRINTED_PACKAGE_READY_TO_SEND, TaxReturnAction.SEND_FOR_PRINTING_REFINE],
    readOnly: true,
    snapshotName: "Printed Package Waiting for Checking (Amendment)",
    };
    static PRINTED_PACKAGE_READY_TO_SEND_AMENDMENT: TaxReturnStatus = {
    id: 159, //amendmentPrintedPackageReadyToSend
    name:"Printed Package: Ready to Send (Amendment)",
    step: TaxReturnStep.READY_TO_SEND,
    phase: TaxReturnPhase.AMENDMENT,
    actions:(config: ConfigStateService) => [TaxReturnAction.QUESTION_DRIVEN_STATUS],
    readOnly: true,
    snapshotName: "Printed Package: Ready to Send (Amendment)",
    };
    static PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_LODGE_AMENDMENT: TaxReturnStatus = {
    id: 160, //amendmentPhysicalPackageSentTaxpayerToLodge
    name:"Physical Package Sent: TP to Lodge (Amendment)",
    step: TaxReturnStep.PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_LODGE,
    phase: TaxReturnPhase.AMENDMENT,
    actions:(config: ConfigStateService) => [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.AMEND, TaxReturnAction.REVISE_BACK_FOR_CHANGES],
    readOnly: true,
    snapshotName: "Physical Package Sent: TP to Lodge (Amendment)",
    };
    static PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_RETURN_TO_KPMG_AMENDMENT: TaxReturnStatus = {
    id: 161, //amendmentPhysicalPackageSentTaxpayerToReturnToKPMG
    name:"Physical Package Sent: TP to Return to KPMG (Amendment)",
    step: TaxReturnStep.PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_RETURN_TO_KPMG,
    phase: TaxReturnPhase.AMENDMENT,
    actions:(config: ConfigStateService) => [TaxReturnAction.REVISE_BACK_FOR_CHANGES, TaxReturnAction.TAXPAYER_ACCEPTED_NEXT],
    readOnly: true,
    snapshotName: "Physical Package Sent: TP to Return to KPMG (Amendment)",
    };
    static PHYSICAL_PACKAGE_SENT_CLIENT_TO_LODGE_REVISION: TaxReturnStatus = {
    id: 162, //revisionPhysicalPackageSentClientToLodge
    name:"Physical Package Sent: Client to Lodge (Revision)",
    step: TaxReturnStep.PHYSICAL_PACKAGE_SENT_CLIENT_TO_LODGE,
    phase: TaxReturnPhase.REVISION,
    actions:(config: ConfigStateService) => [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.AMEND, TaxReturnAction.REVISE_BACK_FOR_CHANGES],
    readOnly: true,
    snapshotName: "Physical Package Sent: Client to Lodge (Revision)",
    };
    static PHYSICAL_PACKAGE_SENT_CLIENT_TO_RETURN_TO_KPMG_REVISION: TaxReturnStatus = {
    id: 163, //revisionPhysicalPackageSentClientToReturnToKPMG
    name:"Physical Package Sent to TP: Client to Return to KPMG (Revision)",
    step: TaxReturnStep.PHYSICAL_PACKAGE_SENT_CLIENT_TO_RETURN_TO_KPMG,
    phase: TaxReturnPhase.REVISION,
    actions:(config: ConfigStateService) => [TaxReturnAction.REVISE_BACK_FOR_CHANGES, TaxReturnAction.TAXPAYER_ACCEPTED_NEXT],
    readOnly: true,
    snapshotName: "Physical Package Sent to TP: Client to Return to KPMG (Revision)",
    };
    static PHYSICAL_PACKAGE_SENT_CLIENT_TO_LODGE_AMENDMENT: TaxReturnStatus = {
    id: 164, //amendmentPhysicalPackageSentClientToLodge
    name:"Physical Package Sent: Client to Lodge (Amendment)",
    step: TaxReturnStep.PHYSICAL_PACKAGE_SENT_CLIENT_TO_LODGE,
    phase: TaxReturnPhase.AMENDMENT,
    actions:(config: ConfigStateService) => [TaxReturnAction.EXCEPTION_FILING, TaxReturnAction.AMEND, TaxReturnAction.REVISE_BACK_FOR_CHANGES],
    readOnly: true,
    snapshotName: "Physical Package Sent: Client to Lodge (Amendment)",
    };
    static PHYSICAL_PACKAGE_SENT_CLIENT_TO_RETURN_TO_KPMG_AMENDMENT: TaxReturnStatus = {
    id: 165, //amendmentPhysicalPackageSentClientToReturnToKPMG
    name:"Physical Package Sent to TP: Client to Return to KPMG (Amendment)",
    step: TaxReturnStep.PHYSICAL_PACKAGE_SENT_CLIENT_TO_RETURN_TO_KPMG,
    phase: TaxReturnPhase.AMENDMENT,
    actions:(config: ConfigStateService) => [TaxReturnAction.REVISE_BACK_FOR_CHANGES, TaxReturnAction.TAXPAYER_ACCEPTED_NEXT],
    readOnly: true,
    snapshotName: "Physical Package Sent to TP: Client to Return to KPMG (Amendment)",
    };
    static DIGITAL_GATEWAY_UPLOAD: TaxReturnStatus = {
      id: 166,
      name: "Sending To Digital Gateway",
      step: TaxReturnStep.SENDING_TO_DIGITAL_GATEWAY_UPLOAD,
      phase: TaxReturnPhase.ORIGINAL,
      readOnly: true,
      actions: (config: ConfigStateService) => [],
      snapshotName: "Sending To Digital Gateway",
    };

    static REVISION_DIGITAL_GATEWAY_UPLOAD: TaxReturnStatus = {
      id: 167,
      name: "Sending To Digital Gateway (revision)",
      step: TaxReturnStep.SENDING_TO_DIGITAL_GATEWAY_UPLOAD,
      phase: TaxReturnPhase.REVISION,
      readOnly: true,
      actions: (config: ConfigStateService) => [],
      snapshotName: "Sending To Digital Gateway",
    };

    static AMENDMENT_DIGITAL_GATEWAY_UPLOAD: TaxReturnStatus = {
      id: 168,
      name: "Sending To Digital Gateway (amendment)",
      step: TaxReturnStep.SENDING_TO_DIGITAL_GATEWAY_UPLOAD,
      phase: TaxReturnPhase.AMENDMENT,
      readOnly: true,
      actions: (config: ConfigStateService) => [],
      snapshotName: "Sending To Digital Gateway",
    };

    static SENT_DIGITAL_GATEWAY_UPLOAD: TaxReturnStatus = {
      id: 169,
      name: "Sent To Digital Gateway",
      step: TaxReturnStep.SENT_TO_DIGITAL_GATEWAY_UPLOAD,
      phase: TaxReturnPhase.ORIGINAL,
      readOnly: true,
      actions: (config: ConfigStateService) => [TaxReturnAction.REVISE_BACK_FOR_CHANGES],
      snapshotName: "Sent To Digital Gateway",
    };

    static REVISION_SENT_DIGITAL_GATEWAY_UPLOAD: TaxReturnStatus = {
      id: 170,
      name: "Sent To Digital Gateway (revision)",
      step: TaxReturnStep.SENT_TO_DIGITAL_GATEWAY_UPLOAD,
      phase: TaxReturnPhase.REVISION,
      readOnly: true,
      actions: (config: ConfigStateService) => [TaxReturnAction.REVISE_BACK_FOR_CHANGES],
      snapshotName: "Sent To Digital Gateway",
    };

    static AMENDMENT_SENT_DIGITAL_GATEWAY_UPLOAD: TaxReturnStatus = {
      id: 171,
      name: "Sent To Digital Gateway (amendment)",
      step: TaxReturnStep.SENT_TO_DIGITAL_GATEWAY_UPLOAD,
      phase: TaxReturnPhase.AMENDMENT,
      readOnly: true,
      actions: (config: ConfigStateService) => [TaxReturnAction.REVISE_BACK_FOR_CHANGES],
      snapshotName: "Sent To Digital Gateway",
    };




    static TAXPAYER: TaxReturnStatus = {
    id: 200, //taxpayer
    name: "taxpayer",
    step: TaxReturnStep.TAXPAYER,
    phase: TaxReturnPhase.ORIGINAL,
    actions:(config: ConfigStateService) => [],
    readOnly: false,
    snapshotName: "Taxpayer"
    };
    static CLOSED: TaxReturnStatus = {
      id: 99, //taxpayer
      name: "Closed",
      step: TaxReturnStep.CLOSED,
      phase: TaxReturnPhase.ORIGINAL,
      actions: (config: ConfigStateService) => [],
      readOnly: true,
      snapshotName: "Closed"
    };

    static ONE_TEAM_RESPONSE: TaxReturnStatus = {
      id: 1000, // waitingForReviewer1
      name: "COLLABORATE RESPONSE",
      step: TaxReturnStep.RESPONSE_FROM_ONE_TEAM,
      phase: TaxReturnPhase.ORIGINAL,
      actions: (config: ConfigStateService) => [],
      snapshotName: "COLLABORATE RESPONSE",
    };


  id: number;
  name: string;
  step: TaxReturnStep;
  phase: TaxReturnPhase;
  actions: (config: ConfigStateService) => TaxReturnAction[];
  inPrep?: boolean;
  inReview?: boolean;
  readOnly?: boolean;
  snapshotName: string;

  static asList(config?: ConfigStateService, allModules: boolean=false) {
    const common = [
      TaxReturnStatus.READY_FOR_PREPARATION,
      TaxReturnStatus.IN_PREPARATION,
      TaxReturnStatus.PREP_GENERATING_TAX_RETURN,
      TaxReturnStatus.PREP_GENERATION_COMPLETE,
      TaxReturnStatus.WAITING_FOR_FIRST_REVIEWER,
      TaxReturnStatus.IN_FIRST_REVIEW,
      TaxReturnStatus.REVIEW_1_GENERATING_TAX_RETURN,
      TaxReturnStatus.REVIEW_1_GENERATION_COMPLETE,
      TaxReturnStatus.WAITING_FOR_SECOND_REVIEWER,
      TaxReturnStatus.IN_SECOND_REVIEW,
      TaxReturnStatus.REVIEW_2_GENERATING_TAX_RETURN,
      TaxReturnStatus.REVIEW_2_GENERATION_COMPLETE,
      TaxReturnStatus.REVIEW_2_FINAL_PACKAGE_SUBMITTING,
      TaxReturnStatus.LINK_FAIL_UPLOAD,
      TaxReturnStatus.AWAITING_TAXPAYER_APPROVAL,
      TaxReturnStatus.AWAITING_EMPLOYER_APPROVAL,
      TaxReturnStatus.AWAITING_TAXPAYER_EMPLOYER_APPROVAL,
      TaxReturnStatus.TAXPAYER_SUBMITTED_EMPLOYER_FAILED,
      TaxReturnStatus.TAXPAYER_APPROVED_EMPLOYER_FAILED,
      TaxReturnStatus.SENT_FOR_LODGEMENT,
      TaxReturnStatus.TAXPAYER_REJECTED,
      TaxReturnStatus.LODGED,
      TaxReturnStatus.READY_TO_RUN_CALCS,
      TaxReturnStatus.WAITING_FOR_PREFILL,
      TaxReturnStatus.DIGITAL_GATEWAY_UPLOAD,
      TaxReturnStatus.SENT_DIGITAL_GATEWAY_UPLOAD,
      // revision
      TaxReturnStatus.REVISION_READY_FOR_PREPARATION,
      TaxReturnStatus.REVISION_IN_PREPARATION,
      TaxReturnStatus.REVISION_PREP_GENERATING_TAX_RETURN,
      TaxReturnStatus.REVISION_PREP_GENERATION_COMPLETE,
      TaxReturnStatus.REVISION_WAITING_FOR_FIRST_REVIEWER,
      TaxReturnStatus.REVISION_IN_FIRST_REVIEW,
      TaxReturnStatus.REVISION_REVIEW_1_GENERATING_TAX_RETURN,
      TaxReturnStatus.REVISION_REVIEW_1_GENERATION_COMPLETE,
      TaxReturnStatus.REVISION_WAITING_FOR_SECOND_REVIEWER,
      TaxReturnStatus.REVISION_IN_SECOND_REVIEW,
      TaxReturnStatus.REVISION_REVIEW_2_GENERATING_TAX_RETURN,
      TaxReturnStatus.REVISION_REVIEW_2_GENERATION_COMPLETE,
      TaxReturnStatus.REVISION_LINK_FAIL_UPLOAD,
      TaxReturnStatus.REVISION_REVIEW_2_FINAL_PACKAGE_SUBMITTING,
      TaxReturnStatus.REVISION_AWAITING_TAXPAYER_APPROVAL,
      TaxReturnStatus.REVISION_AWAITING_EMPLOYER_APPROVAL,
      TaxReturnStatus.REVISION_AWAITING_TAXPAYER_EMPLOYER_APPROVAL,
      TaxReturnStatus.REVISION_TAXPAYER_SUBMITTED_EMPLOYER_FAILED,
      TaxReturnStatus.REVISION_TAXPAYER_APPROVED_EMPLOYER_FAILED,
      TaxReturnStatus.REVISION_SENT_FOR_LODGEMENT,
      TaxReturnStatus.REVISION_TAXPAYER_REJECTED,
      TaxReturnStatus.REVISION_LODGED,
      TaxReturnStatus.REVISION_DIGITAL_GATEWAY_UPLOAD,
      TaxReturnStatus.REVISION_SENT_DIGITAL_GATEWAY_UPLOAD,
      // amendment
      TaxReturnStatus.AMENDMENT_READY_FOR_PREPARATION,
      TaxReturnStatus.AMENDMENT_IN_PREPARATION,
      TaxReturnStatus.AMENDMENT_PREP_GENERATING_TAX_RETURN,
      TaxReturnStatus.AMENDMENT_PREP_GENERATION_COMPLETE,
      TaxReturnStatus.AMENDMENT_WAITING_FOR_FIRST_REVIEWER,
      TaxReturnStatus.AMENDMENT_IN_FIRST_REVIEW,
      TaxReturnStatus.AMENDMENT_REVIEW_1_GENERATING_TAX_RETURN,
      TaxReturnStatus.AMENDMENT_REVIEW_1_GENERATION_COMPLETE,
      TaxReturnStatus.AMENDMENT_WAITING_FOR_SECOND_REVIEWER,
      TaxReturnStatus.AMENDMENT_IN_SECOND_REVIEW,
      TaxReturnStatus.AMENDMENT_REVIEW_2_GENERATING_TAX_RETURN,
      TaxReturnStatus.AMENDMENT_REVIEW_2_GENERATION_COMPLETE,
      TaxReturnStatus.AMENDMENT_LINK_FAIL_UPLOAD,
      TaxReturnStatus.AMENDMENT_REVIEW_2_FINAL_PACKAGE_SUBMITTING,
      TaxReturnStatus.AMENDMENT_AWAITING_TAXPAYER_APPROVAL,
      TaxReturnStatus.AMENDMENT_AWAITING_EMPLOYER_APPROVAL,
      TaxReturnStatus.AMENDMENT_AWAITING_TAXPAYER_EMPLOYER_APPROVAL,
      TaxReturnStatus.AMENDMENT_TAXPAYER_SUBMITTED_EMPLOYER_FAILED,
      TaxReturnStatus.AMENDMENT_TAXPAYER_APPROVED_EMPLOYER_FAILED,
      TaxReturnStatus.AMENDMENT_SENT_FOR_LODGEMENT,
      TaxReturnStatus.AMENDMENT_TAXPAYER_REJECTED,
      TaxReturnStatus.AMENDMENT_LODGED,
      TaxReturnStatus.AMENDMENT_DIGITAL_GATEWAY_UPLOAD,
      TaxReturnStatus.AMENDMENT_SENT_DIGITAL_GATEWAY_UPLOAD,

      // sQNR Generation
      TaxReturnStatus.CHECKING_FOR_PREFILL,
      TaxReturnStatus.PREFILL_LOAD_FAILED,
      TaxReturnStatus.READY_TO_RUN_CALCS_SQNR,
      // Taxpayer status
      TaxReturnStatus.TAXPAYER,
      TaxReturnStatus.ONE_TEAM_RESPONSE
    ];
    const qnr = [
      TaxReturnStatus.QUESTIONNAIRE_OUTSTANDING,
      TaxReturnStatus.QUESTIONNAIRE_LOAD_FAILED,
    ];
    const auQnrs = [
      TaxReturnStatus.WAITING_TO_CREATE_SIMPLE_QNR,
      TaxReturnStatus.FAILED_TO_CREATE_SIMPLE_QNR,
      TaxReturnStatus.SIMPLE_QNR_OUTSTANDING,
      TaxReturnStatus.SIMPLE_QNR_LOAD_FAILED,
      TaxReturnStatus.WAITING_PROCESSING_NO_QNR,
    ];
    const aps = [
      TaxReturnStatus.WAITING_FOR_ITR_ROBOT,
      TaxReturnStatus.ITR_ROBOT_FAILED,
      // NOTE(mike): Due to lack of amendment/revision lodgement-failed, I've stuck the lone lodgement failed with au/aps
      TaxReturnStatus.LODGEMENT_FAILED,
    ];
    const prePrep = [
      TaxReturnStatus.PRE_PREPARATION,
      TaxReturnStatus.WAITING_FOR_PRE_PREPARATION,
    ];
    // adding statuses to the end of the tax return workflow
    // printing returns, sending to taxpayers
    const chinaEndFlow = [
      TaxReturnStatus.ELECTRONIC_PACKAGE_SENT_TAXPAYER_TO_LODGE,
      TaxReturnStatus.SENT_FOR_PRINTING,
      TaxReturnStatus.ELECTRONIC_PACKAGE_SENT_TAXPAYER_TO_LODGE_REVISION,
      TaxReturnStatus.ELECTRONIC_PACKAGE_SENT_TAXPAYER_TO_LODGE_AMENDMENT,
      TaxReturnStatus.ELECTRONIC_PACKAGE_SENT_CLIENT_TO_LODGE,
      TaxReturnStatus.ELECTRONIC_PACKAGE_SENT_CLIENT_TO_LODGE_REVISION,
      TaxReturnStatus.ELECTRONIC_PACKAGE_SENT_CLIENT_TO_LODGE_AMENDMENT,
      TaxReturnStatus.AWAITING_EXCEPTION_FILING,
      TaxReturnStatus.AWAITING_EXCEPTION_FILING_REVISION,
      TaxReturnStatus.AWAITING_EXCEPTION_FILING_AMENDMENT,
      TaxReturnStatus.PRINTED_PACKAGE_WAITING_FOR_CHECKING,
      TaxReturnStatus.PRINTED_PACKAGE_READY_TO_SEND,
      TaxReturnStatus.LODGEMENT_IN_PROGRESS,
      TaxReturnStatus.LODGEMENT_IN_PROGRESS_REVISION,
      TaxReturnStatus.LODGEMENT_IN_PROGRESS_AMENDMENT,
      TaxReturnStatus.PHYSICAL_PACKAGE_SENT_CLIENT_TO_LODGE,
      TaxReturnStatus.PHYSICAL_PACKAGE_SENT_CLIENT_TO_RETURN_TO_KPMG,
      TaxReturnStatus.PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_LODGE,
      TaxReturnStatus.PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_RETURN_TO_KPMG,
      TaxReturnStatus.SENT_FOR_PRINTING_INFORMATION_NOT_COMPLETE,
      TaxReturnStatus.SENT_FOR_PRINTING_REVISION,
      TaxReturnStatus.SENT_FOR_PRINTING_INFORMATION_NOT_COMPLETE_REVISION,
      TaxReturnStatus.PRINTED_PACKAGE_WAITING_FOR_CHECKING_REVISION,
      TaxReturnStatus.PRINTED_PACKAGE_READY_TO_SEND_REVISION,
      TaxReturnStatus.PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_LODGE_REVISION,
      TaxReturnStatus.PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_RETURN_TO_KPMG_REVISION,
      TaxReturnStatus.SENT_FOR_PRINTING_AMENDMENT,
      TaxReturnStatus.SENT_FOR_PRINTING_INFORMATION_NOT_COMPLETE_AMENDMENT,
      TaxReturnStatus.PRINTED_PACKAGE_WAITING_FOR_CHECKING_AMENDMENT,
      TaxReturnStatus.PRINTED_PACKAGE_READY_TO_SEND_AMENDMENT,
      TaxReturnStatus.PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_LODGE_AMENDMENT,
      TaxReturnStatus.PHYSICAL_PACKAGE_SENT_TAXPAYER_TO_RETURN_TO_KPMG_AMENDMENT,
      TaxReturnStatus.PHYSICAL_PACKAGE_SENT_CLIENT_TO_LODGE_REVISION,
      TaxReturnStatus.PHYSICAL_PACKAGE_SENT_CLIENT_TO_RETURN_TO_KPMG_REVISION,
      TaxReturnStatus.PHYSICAL_PACKAGE_SENT_CLIENT_TO_LODGE_AMENDMENT,
      TaxReturnStatus.PHYSICAL_PACKAGE_SENT_CLIENT_TO_RETURN_TO_KPMG_AMENDMENT,
      TaxReturnStatus.CLOSED,
    ]

    if (allModules) {
      return [
        ...common,
        ...qnr,
        ...auQnrs,
        ...aps,
        ...prePrep,
        ...chinaEndFlow,
      ];
    }

    const statuses = [
      ...common,
      ...qnr,
    ];

    if (config && config.tenant === Tenant.SG) {
      statuses.push(...prePrep);
    }
    if (config && (config.tenant === Tenant.HK || config.tenant === Tenant.CN) ) {
      statuses.push(...chinaEndFlow);
    }
    if (config && config.featureFlags.aps) {
      statuses.push(...aps);
    }
    if (config && config.featureFlags.auQnrs) {
      statuses.push(...auQnrs);
    }



    return statuses;
  }




  static ESS_READY_FOR_PREPARATION: TaxReturnStatus = {
    id: 50, // waitingForPrep
    name: "Ready for preparation",
    step: TaxReturnStep.READY_FOR_PREP,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.PREPARE],
    snapshotName: "Ready for Preparation",
  };
  static ESS_IN_PREPARATION: TaxReturnStatus = {
    id: 1, // prep
    name: "In preparation",
    step: TaxReturnStep.PREPARATION,
    phase: TaxReturnPhase.ORIGINAL,
    inPrep: true,
    actions: (config: ConfigStateService) => [TaxReturnAction.SUBMIT_FOR_REVIEW],
    snapshotName: "Preparation",
  };
  static ESS_WAITING_FOR_REVIEW: TaxReturnStatus = {
    id: 2, // waitingForReviewer1
    name: "Waiting for review",
    step: TaxReturnStep.READY_FOR_REVIEW,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.REVIEW],
    snapshotName: "Ready for Review",
  };

  static ESS_IN_REVIEW: TaxReturnStatus = {
    id: 3, // review
    name: "In review",
    step: TaxReturnStep.IN_REVIEW,
    phase: TaxReturnPhase.ORIGINAL,
    inReview: true,
    actions: (config: ConfigStateService) => [TaxReturnAction.BACK_FOR_CHANGES, TaxReturnAction.REVIEW_COMPLETED],
    snapshotName: "Review",
  };

  static ESS_AWAITING_CLIENT_APPROVAL: TaxReturnStatus = {
    id: 101, //submitted to employer
    name: "Awaiting Client Approval",
    step: TaxReturnStep.AWAITING_CLIENT_APPROVAL,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.REVISE, TaxReturnAction.LODGED],
    snapshotName: "Awaiting Client Approval",
  };



  static ESS_LODGED: TaxReturnStatus = {
    id: 7, // lodged
    name: "Lodged",
    step: TaxReturnStep.LODGED,
    phase: TaxReturnPhase.ORIGINAL,
    actions: (config: ConfigStateService) => [TaxReturnAction.AMEND],
    snapshotName: "Lodged",
  };


  static essStatusList() {
    return [
      TaxReturnStatus.ESS_READY_FOR_PREPARATION,
      TaxReturnStatus.ESS_IN_PREPARATION,
      TaxReturnStatus.ESS_WAITING_FOR_REVIEW,
      TaxReturnStatus.ESS_IN_REVIEW,
      TaxReturnStatus.ESS_AWAITING_CLIENT_APPROVAL,
      TaxReturnStatus.ESS_LODGED
    ];
  }

  static byId(id?: number, tenant = null) {
    if (taxReturnStatusById === null) {
      taxReturnStatusById = {};
      const a = (tenant === Tenant.ESS) ? TaxReturnStatus.essStatusList() : TaxReturnStatus.asList(undefined, true);
      a.forEach(s => taxReturnStatusById[s.id] = s);
    }
    return taxReturnStatusById[id || 0];
  }
}
